import { device } from '@/utils/index'

const content = [
    // 第一章 第二节 Listening and Speaking
    // 小标题
    {
        key: 'section1.3',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Listening and Speaking", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/title-back.png"),
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    // 小标题
    {
        key: 'section1.4',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Listen and Practice", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/ListenandPractice-bg.png"),
        titleImageWidth: 524,
        titleImagePosition: 'left',
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 36, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 112, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    {
        key: 'section1.5',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Before You Listen", // *必填* 标题文本内容
        titleImageType: 1,
        titleImage: require("@/assets/images/books/book2/title-icon1.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            height: 49,

            width: 'auto',

            lineHeight: 49, // 行高  默认：46
            textIndent: 20, // 首行缩进  标题前带图标的写30，不带图标的写20  
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            marginLeft: 20,
            paddingRight: 20,
            margin: 24,
            marginTop: 20,
            marginBottom: 0,

        },

    },
    // 模板样式 单个带边框
    {
        key: 'section1.6',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 5,
            backgroundColor: '#FFFFFF',
            borderRadius: 0,
            // paddingTop: 0,
            // paddingBottom: 0,
            // borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [{
            key: 'section1.6.1',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
                type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                width: 55,
                height: 40,
                text: 'I',
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    fontSize: 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#5CA683', // 背景颜色  默认：无
                    backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                    paddingLeft: 0,
                    paddingRight: 15,
                    marginLeft: 0,
                    marginRight: 14,
                    marginTop: 0,
                    marginBottom: 0,
                    top: 0,
                    left: 0,
                }
            },
            content: { //右侧文本内容，目前只有一段文字
                key: 'section1.6.1.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.6.1.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'Listen and learn the words and expressions below.', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'ArialMT', // 字体，本地配置的字体
                            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        },
                    }
                ],
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },
            },
            // 段落内外间距
            paragraphStyle: {
                marginTop: 5,
                marginBottom: 0,
                paddingLeft: 20,
                paddingRight: 20,

            }
        },
        {
            key: 'section1.6.2',
            type: "wordAudio",
            category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
            // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
            text: "New Words and Expressions", // *必填* 标题文本内容
            isexpand: false, //是否展开
            // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
            textStyle: {
                marginTop: 20
                // fontFamily: 'Arial', // 字体，本地配置的字体
                // fontSize: 26, // 文字大小  默认：26
                // height:68,
                // width:'auto',
                // lineHeight: 68, // 行高  默认：46
                // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                // color: '#fff', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            },
            content: [{
                key: 'section1.6.2.1', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/01 aristocrat.mp3'), // 单词音频
                content: [{
                    key: 'section1.6.2.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'aristocrat', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '/ˈærɪstəkræt/', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: 'n. ',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 28,
                        fontItalic: 1,
                        lineHeight: 36
                    }
                },
                {
                    text: '贵族（成员）',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }
                ]
            },
            {
                key: 'section1.6.2.2', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/02 patriotism.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.2.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'patriotism', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '/ˈpætriətɪzəm/', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: 'n. ',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 28,
                        fontItalic: 1,
                        lineHeight: 36
                    }
                },
                {
                    text: '爱国精神；爱国主义',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }
                ],

            },
            {
                key: 'section1.6.2.3', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/03 stilt.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.3.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'stilt', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '/stɪlt/', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: 'n. ',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 28,
                        fontItalic: 1,
                        lineHeight: 36
                    }
                },
                {
                    text: '高跷',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }
                ],

            },
            {
                key: 'section1.6.2.4', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/04 associate.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.4.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'associate', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '/əˈsəʊsieɪt/', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: 'v. ',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 28,
                        fontItalic: 1,
                        lineHeight: 36
                    }
                },
                {
                    text: '联系；联想',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }
                ],

            }, {
                key: 'section1.6.2.5', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/05 wormwood.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.5.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'wormwood', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '/ˈwɜːmwʊd/', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: 'n. ',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 28,
                        fontItalic: 1,
                        lineHeight: 36
                    }
                },
                {
                    text: '蒿；苦艾',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }
                ],

            },
            {
                key: 'section1.6.2.6', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/06 wrap.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.6.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'wrap', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '/ræp/', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: 'v. ',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 28,
                        fontItalic: 1,
                        lineHeight: 36
                    }
                },
                {
                    text: '包；裹',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }
                ],

            },
            {
                key: 'section1.6.2.7', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/07 in memory of sb.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.7.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'in memory of sb. ', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '为了纪念某人',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],

            }, {
                key: 'section1.6.2.8', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/08 ward off.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.8.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'ward of', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '击退；避免（危险、疾病、攻击等）',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],

            }, {
                key: 'section1.6.2.9', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/09 cheer for.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.9.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'cheer for', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '为',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '……',
                    textStyle: {
                        color: '#999999',
                        fontFamily: '宋体', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '欢呼；为',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '……',
                    textStyle: {
                        color: '#999999',
                        fontFamily: '宋体', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '助威',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],

            }, {
                key: 'section1.6.2.10', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/10 stilt walking.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.10.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'stilt walking', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '踩高跷',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],
            }, {
                key: 'section1.6.2.11', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/11 associate sth. with sth.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.11.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'associate sth. with sth.', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '将',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '……',
                    textStyle: {
                        color: '#999999',
                        fontFamily: '宋体', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '和',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '……',
                    textStyle: {
                        color: '#999999',
                        fontFamily: '宋体', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '联系起来',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],

            }, {
                key: 'section1.6.2.12', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/12 wrap sth. (up) in sth.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.12.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'wrap sth. (up) in sth. ', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '用',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '……',
                    textStyle: {
                        color: '#999999',
                        fontFamily: '宋体', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '包裹（或包扎、覆盖等）',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                },{
                    text: '……',
                    textStyle: {
                        color: '#999999',
                        fontFamily: '宋体', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],

            }, {
                key: 'section1.6.2.13', // *必填* 唯一标识
                type: "", // *必填*
                // word_title: 'aristocrat', // 单词
                isPlay: false, //是否播放
                word_url: require('@/assets/audio/2-1/13 look forward to doing sth.mp3'), // 单词音频
                // word_title_style: {
                //   color:'#333333',
                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                //   fontSize: 32, // 文字大小  默认：26
                //   width:'auto',
                //   fontWeight:'bold',
                //   lineHeight:36
                //  },
                content: [{
                    key: 'section1.6.2.13.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'look forward to doing sth.', // *必填* 文本内容
                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                    popText: '', // 气泡的内容
                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                    textStyle: {
                        color: '#333333',
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: 32, // 文字大小  默认：26
                        width: 'auto',
                        fontWeight: 'bold',
                        lineHeight: 36
                    },
                },],
                word_mark: '', // 音标
                word_mark_style: {
                    color: '#999999',
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    width: 'auto',
                    lineHeight: 36
                },
                word_translate: [{
                    text: '期待做某事',
                    textStyle: {
                        color: '#999999',
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontSize: 22,
                        lineHeight: 36
                    }
                }],

            }
            ]
        },
        ],
    },
    // 模板样式 单个带边框
    {
        key: 'section1.7',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [{
            key: 'section1.7.1',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
                type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                width: 55,
                height: 40,
                text: 'II',
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    fontSize: 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#5CA683', // 背景颜色  默认：无
                    backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                    paddingLeft: 0,
                    paddingRight: 15,
                    marginLeft: 0,
                    marginRight: 14,
                    marginTop: 0,
                    marginBottom: 0,
                    top: 0,
                    left: 0,
                }
            },
            content: { //右侧文本内容，目前只有一段文字
                key: 'section1.7.1.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.7.1.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'Match the festivals with the corresponding statements and discuss which is your favorite festival with your partner.', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'ArialMT', // 字体，本地配置的字体
                            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        },
                    }
                ],
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },
            },
            // 段落内外间距
            paragraphStyle: {
                marginTop: 0,
                marginBottom: 0,
                paddingLeft: 20,
                paddingRight: 20,

            }
        },
        // 交互 连连看
        {
            key: 'section1.7.2', // *必填* 唯一标识
            type: 'action', // *必填* 类型：交互
            actionType: 1, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
            styleType: 2, // 样式类型 actionType = 2 时 1：默认示例中样式 2：英语中样式，拖拽字母 3：英语中，文字拖拽样式
            titleStyle: {},
            // isBlock: 1, // 是否默认存在一个区域框
            content: {
                // 连连看
                key: 'action2',
                leftData: [
                    {
                        key: 'action2.1.1',
                        actionKey: 'action2',
                        cover: require("@/assets/images/books/book2/action/connection-left-1.png"),
                        answerKey: 'key1'
                    },
                    {
                        key: 'action2.1.2',
                        actionKey: 'action2',
                        cover: require("@/assets/images/books/book2/action/connection-left-2.png"),
                        answerKey: 'key2'
                    },
                    {
                        key: 'action2.1.3',
                        actionKey: 'action2',
                        cover: require("@/assets/images/books/book2/action/connection-left-3.png"),
                        answerKey: 'key3'
                    },
                    {
                        key: 'action2.1.4',
                        actionKey: 'action2',
                        cover: require("@/assets/images/books/book2/action/connection-left-4.png"),
                        answerKey: 'key4'
                    },
                    {
                        key: 'action2.1.5',
                        actionKey: 'action2',
                        cover: require("@/assets/images/books/book2/action/connection-left-5.png"),
                        answerKey: 'key5'
                    },
                    {
                        key: 'action2.1.6',
                        actionKey: 'action2',
                        cover: require("@/assets/images/books/book2/action/connection-left-6.png"),
                        answerKey: 'key6'
                    }
                ],
                rightData: [
                    {
                        key: 'action2.2.1',
                        actionKey: 'action2',
                        actionLabel: 'A',
                        actionContent: [
                            {
                                key: 'section1.7.2.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.7.2.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'The most important traditional Chinese festival, marking the start of the ', // *必填* 文本内容
                                        textStyle: {
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.1.2', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        text: 'lunar calendar.', // *必填* 文本内容
                                        popTitle: '',
                                        popText: '',
                                        popWord: true,
                                        isPlay: false,
                                        word_url: require('@/assets/audio/2-2/01 lunar calender.mp3'), // 单词音频,
                                        popWordTitle: [
                                            {
                                                key: 'section1.7.2.1.2.1',
                                                text: 'lunar calendar.',
                                                textStyle: {
                                                    fontFamily: 'Arial',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    // fontSize: 18,
                                                }
                                            }
                                        ],
                                        popWordList: [
                                            {
                                                key: 'section1.7.2.1.2.3',
                                                // text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.1.2.3.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            {
                                                                key: 'section1.7.2.1.2.3.1.1',
                                                                text: '阴历，也叫农历，或者夏历，在天文学中与阳历对应，指主要按月亮的月相周期来安排的历法。平年十二个月，大月三十天，小月二十九天，全年354天或355天（一年中哪个月大，哪个月小，年年不同）。由于每年的天数比太阳年约差十一天，所以在十九年里设置七个闰月，有闰月的年份全年383天或384天。又根据太阳的位置，把一个太阳年分成二十四个节气，以利于农业种植等活动。纪年用天干地支搭配，六十年周而复始。这种历法相传创始于夏代，所以又称为夏历。也叫旧历。',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 24,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ],
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    fontSize: 26, // 文字大小  默认：20
                                    lineHeight: 32, // 行高  默认：36
                                },
                            },
                        ],
                        answerKey: 'key5'
                    },
                    {
                        key: 'action2.2.2',
                        actionKey: 'action2',
                        actionLabel: 'B',
                        actionContent: [
                            {
                                key: 'section1.7.2.2', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.7.2.2.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'Be celebrated on the 15th day of the first lunar month.', // *必填* 文本内容
                                        textStyle: {
                                        },
                                    }
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    fontSize: 26, // 文字大小  默认：20
                                    lineHeight: 32, // 行高  默认：36
                                },
                            },
                        ],
                        answerKey: 'key1'
                    },
                    {
                        key: 'action2.2.3',
                        actionKey: 'action2',
                        actionLabel: 'C',
                        actionContent: [
                            {
                                key: 'section1.7.2.3', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.7.2.3.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'A time when people ', // *必填* 文本内容
                                        textStyle: {
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.3.2', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        text: 'honor', // *必填* 文本内容
                                        popTitle: '',
                                        popText: '',
                                        popWord: true,
                                        isPlay: false,
                                        word_url: require('@/assets/audio/2-2/02 honor.mp3'), // 单词音频,
                                        popWordTitle: [
                                            {
                                                key: 'section1.7.2.3.2.1',
                                                text: 'honor',
                                                textStyle: {
                                                    fontFamily: 'Arial',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    // fontSize: 18,
                                                }
                                            },
                                            {
                                                key: 'section1.7.2.3.2.2',
                                                text: '/ˈɒnə(r)/',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#999999',
                                                    // fontSize: 14,
                                                }
                                            }
                                        ],
                                        popWordList: [
                                            {
                                                key: 'section1.7.2.3.2.3',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.3.2.3.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.1',
                                                                text: 'vt. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 26,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.2',
                                                                text: 'to regard or treat (someone) with admiration and respect  ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 26,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.3',
                                                                text: '尊敬，给以荣誉',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ],
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.3.3', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'their  ', // *必填* 文本内容
                                        textStyle: {
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.3.4', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        text: 'ancestors.', // *必填* 文本内容
                                        popTitle: '',
                                        popText: '',
                                        popWord: true,
                                        isPlay: false,
                                        word_url: require('@/assets/audio/2-2/03 ancestor.mp3'), // 单词音频,
                                        popWordTitle: [
                                            {
                                                key: 'section1.7.2.3.4.1',
                                                text: 'ancestor',
                                                textStyle: {
                                                    fontFamily: 'Arial',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    // fontSize: 18,
                                                }
                                            },
                                            {
                                                key: 'section1.7.2.3.4.2',
                                                text: '/ˈænsestə(r)/',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#999999',
                                                    // fontSize: 14,
                                                }
                                            }
                                        ],
                                        popWordList: [
                                            {
                                                key: 'section1.7.2.3.4.3',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.3.4.3.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.3.4.3.1.1',
                                                                text: 'n. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.4.3.1.2',
                                                                text: 'one from whom a person is descended and who is usually more remote in the line of descent than a grandparent  ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.4.3.1.3',
                                                                text: '祖先；祖宗',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ],
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    fontSize: 26, // 文字大小  默认：20
                                    lineHeight: 32, // 行高  默认：36
                                },
                            },
                        ],
                        answerKey: 'key6'
                    },
                    {
                        key: 'action2.2.4',
                        actionKey: 'action2',
                        actionLabel: 'D',
                        actionContent: [
                            {
                                key: 'section1.7.2.4', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.7.2.4.1', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        text: 'Be known for', // *必填* 文本内容
                                        popTitle: '',
                                        popText: '',
                                        popWord: true,
                                        isPlay: false,
                                        word_url: require('@/assets/audio/2-2/04 be known for.mp3'), // 单词音频,
                                        popWordTitle: [
                                            {
                                                key: 'section1.7.2.3.2.1',
                                                text: 'Be known for',
                                                textStyle: {
                                                    fontFamily: 'Arial',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    // fontSize: 18,
                                                }
                                            },
                                        ],
                                        popWordList: [
                                            {
                                                key: 'section1.7.2.3.2.3',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.3.2.3.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.1',
                                                                text: '因',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.2',
                                                                text: '……',
                                                                textStyle: {
                                                                    fontFamily: '宋体',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.3',
                                                                text: '而著名',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.4',
                                                                text: '（=be famous for）',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.3.1.5',
                                                                text: '，其后所接内容表示某人或物的特点、特长等。',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4',
                                                text: '例句',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.3.2.4.1',
                                                        text: '',
                                                        textFlex: true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.3.2.4.1.1',
                                                                text: 'e.g. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.4.1.2',
                                                                text: 'Guilin is known for her beautiful mountains and rivers.',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.4.1.3',
                                                                text: '桂林因其美丽的山水而闻名。',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                            {
                                                key: 'section1.7.2.3.2.5',
                                                text: '词以类记',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.3.2.5.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.3.2.5.1.1',
                                                                text: 'be known as：',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.5.1.2',
                                                                text: '作为',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.5.1.3',
                                                                text: '……',
                                                                textStyle: {
                                                                    fontFamily: '宋体',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.5.1.4',
                                                                text: '而著名',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.5.2',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.3.2.5.2.1',
                                                                text: 'be known to：',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.5.2.2',
                                                                text: '为',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.5.2.3',
                                                                text: '……',
                                                                textStyle: {
                                                                    fontFamily: '宋体',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.3.2.5.2.4',
                                                                text: '所了解/知道',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ],
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.4.2', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: ' exciting dragon boat races and eating ', // *必填* 文本内容
                                        textStyle: {

                                        },
                                    }
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    fontSize: 26, // 文字大小  默认：20
                                    lineHeight: 32, // 行高  默认：36
                                },
                            },
                        ],
                        answerKey: 'key2'
                    },
                    {
                        key: 'action2.2.5',
                        actionKey: 'action2',
                        actionLabel: 'E',
                        actionContent: [
                            {
                                key: 'section1.7.2.5', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.7.2.5.1', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        text: 'Commemorate', // *必填* 文本内容
                                        popTitle: '',
                                        popText: '',
                                        popWord: true,
                                        isPlay: false,
                                        word_url: require('@/assets/audio/2-2/05 commemorate.mp3'), // 单词音频,
                                        popWordTitle: [
                                            {
                                                key: 'section1.7.2.5.1.1',
                                                text: 'commemorate',
                                                textStyle: {
                                                    fontFamily: 'Arial',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    // fontSize: 18,
                                                }
                                            },
                                            {
                                                key: 'section1.7.2.5.1.2',
                                                text: '/kəˈmeməreɪt/',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#999999',
                                                    // fontSize: 14,
                                                }
                                            }
                                        ],
                                        popWordList: [
                                            {
                                                key: 'section1.7.2.5.1.3',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.5.1.3.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.5.1.3.1.1',
                                                                text: 'v. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.3.1.2',
                                                                text: 'to remember officially and give respect to a great person or event, especially by a public ceremony or by making a statue or special building  ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.3.1.3',
                                                                text: '纪念，缅怀',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                            {
                                                key: 'section1.7.2.5.1.4',
                                                text: '例句',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.5.1.4.1',
                                                        text: '',
                                                        textFlex: true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.5.1.4.1.1',
                                                                text: 'e.g. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.4.1.2',
                                                                text: 'A statue has been built to commemorate the 100th anniversary of the poet’s birthday.',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.4.1.3',
                                                                text: '为纪念诗人百年诞辰建起了一尊雕像。',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ],
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.5.2', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '  the founding of the People’s Republic of China.', // *必填* 文本内容
                                        textStyle: {

                                        },
                                    }
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    fontSize: 26, // 文字大小  默认：20
                                    lineHeight: 32, // 行高  默认：36
                                },
                            },
                        ],
                        answerKey: 'key4'
                    },
                    {
                        key: 'action2.2.6',
                        actionKey: 'action2',
                        actionLabel: 'F',
                        actionContent: [
                            {
                                key: 'section1.7.2.6', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.7.2.6.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'A time for families to get together and ', // *必填* 文本内容
                                        textStyle: {

                                        },
                                    },
                                    {
                                        key: 'section1.7.2.6.2', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        text: 'admire', // *必填* 文本内容
                                        popTitle: '',
                                        popText: '',
                                        popWord: true,
                                        isPlay: false,
                                        word_url: require('@/assets/audio/2-2/06 admire.mp3'), // 单词音频,
                                        popWordTitle: [
                                            {
                                                key: 'section1.7.2.5.1.1',
                                                text: 'admire',
                                                textStyle: {
                                                    fontFamily: 'Arial',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    // fontSize: 18,
                                                }
                                            },
                                            {
                                                key: 'section1.7.2.5.1.2',
                                                text: '/ədˈmaɪə(r)/',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#999999',
                                                    // fontSize: 14,
                                                }
                                            }
                                        ],
                                        popWordList: [
                                            {
                                                key: 'section1.7.2.5.1.3',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.5.1.3.1',
                                                        text: '',
                                                        // textFlex:true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.5.1.3.1.1',
                                                                text: 'v. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.3.1.2',
                                                                text: 'to find someone or something attractive and pleasant to look at; to respect and approve of someone or their behaviour  ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.3.1.3',
                                                                text: '欣赏；羡慕；钦佩；赞赏',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                            {
                                                key: 'section1.7.2.5.1.4',
                                                text: '例句',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.5.1.4.1',
                                                        text: '',
                                                        textFlex: true,
                                                        textStyle: {
                                                        },
                                                        content: [
                                                            // 
                                                            {
                                                                key: 'section1.7.2.5.1.4.1.1',
                                                                text: 'e.g. ',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.4.1.2',
                                                                text: 'We stood for a few moments, admiring the view.',
                                                                textStyle: {
                                                                    fontFamily: 'Calibri',
                                                                    color: '#333',
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36
                                                                },
                                                            },
                                                            {
                                                                key: 'section1.7.2.5.1.4.1.3',
                                                                text: '我们驻足了一会儿，欣赏美丽的景色。',
                                                                textStyle: {
                                                                    fontFamily: 'STXihei',
                                                                    color: '#333',
                                                                    // fontSize: 13,
                                                                    // lineHeight: 36,
                                                                },
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ],
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section1.7.2.6.3', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '     the full moon while enjoying mooncakes.', // *必填* 文本内容
                                        textStyle: {

                                        },
                                    }
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    fontSize: 26, // 文字大小  默认：20
                                    lineHeight: 32, // 行高  默认：36
                                },
                            },
                        ],
                        answerKey: 'key3'
                    }
                ],

            },
        },
        ],
    },
    {
        key: 'section1.8',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "While You Listen", // *必填* 标题文本内容
        titleImageType: 1,
        titleImage: require("@/assets/images/books/book2/title-icon1.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 20, // 首行缩进  标题前带图标的写30，不带图标的写20
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            marginLeft: 20,
            paddingRight: 20,
            margin: 24,
            marginTop: 20,
            marginBottom: 0,

        },

    },
    // 模板样式 单个带边框
    {
        key: 'section1.9',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 5,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [
            // 音频
            {
                key: 'section1.9.1', // *必填* 唯一标识
                type: 'audio', // *必填* 类型：视频
                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                playerInline: 1, // 是否是行内播放 1：行内播放
                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                content: [ // *必填* 视频列表
                    {
                        key: 'section1.9.1.1', // *必填* 唯一标识
                        url: require("@/assets/video/book2/Whileyoulisten.mp3"), // *必填* 视频地
                        title: 'Dialogue', // 视频标题
                        subtitle: 'Dialogue', // 视频副标题 只在全部显示时使用
                        titleStyle: {
                            // 根据需要是否加标题样式
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                        contentStyle: {}
                    },
                ],
            },
            {
                key: 'section1.9.2',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'I',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },
                    popContent: { // 气泡
                        key: 'section1.9.2.1', // *必填* 唯一标识
                        category: 'popover', // *必填* 内容类型 text：文本
                        // text: '轴线', // *必填* 文本内容
                        textSlot: 1, // 是否以插槽方式引入内容
                        // popTitle: '轴线的名词解释',
                        popText: '',
                        content: [{
                            key: 'section1.9.2.1.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '参考答案', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '1. The Dragon Boat Festival.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.3', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.3.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '2. The Warring States Period.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.4', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.4.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '3. He is known for his patriotism.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },

                        ],
                        textStyle: {

                        },
                    },
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.9.2.2', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.9.2.2.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Listen to the dialogue and answer the following questions.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 50,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            // 答题
            {
                key: 'section1.9.3.0', // *必填* 唯一标识
                type: 'question', // *必填* 类型：答题
                onlyContent: 1, // 只存在内容
                submitBtnStyle: { //按钮的样式
                    width: 180,
                    height: 52,
                    lineHeight: 52, // 行高  默认：46
                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                },
                content: [{
                    "topic_id": 57,
                    "id": 57,
                    "type_id": 4,
                    "typenm": "简答题",
                    "shorttag": "",
                    "showway": "",
                    "topic_score": "8.00",
                    "isauto": 0,
                    "info": "",
                    "km": "",
                    "stem_url": "",
                    "audiofile": "",
                    "audiofile_suffix": "",
                    "audiofile_title": "附件下载",
                    "is_collect": 0,
                    "status": 0,
                    "is_play": 0,
                    "issign": 0,
                    "isok": 0,
                    "isdone": 0,
                    "getscore": 0,
                    "comment": "",
                    "ischeck": 0,
                    "ps_info": "根据相关要求，完成下列题目。",
                    "topic_sub": [{
                        "shorttag": "",
                        "direction": 0,
                        "type_id": 4,
                        "typenm": "简答题",
                        "score": "8.00",
                        "topic_id": 57,
                        "sub_id": 1,
                        "isauto": 0,
                        "is_upload": 0,
                        "para44_id": 0,
                        "upload_explain": "",
                        "options": [],
                        "showway": "",
                        "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">1 <\/span>Which festival is Pia going to celebrate?<\/span><\/p>",
                        "subanalysis": "",
                        "sortid": 1,
                        "file_name": "",
                        "user_answer": [],
                        "brief_answer": {},
                        "user_status": -1,
                        "answer_img": {},
                        "topic_answer": [{
                            "topic_id": 57,
                            "sub_id": 1,
                            "sortid": 1,
                            "ask": "",
                            "answer": "",
                            "askend": null,
                            "answer_id": 1,
                            "answer_url": "",
                            "answertitle": null,
                            "score": "8.00",
                            "operation_score": 0
                        }],
                        "video_list": [],
                        "isok": 0,
                        "isdone": 0,
                        "concat_answer": "",
                        "user_concat_answer": ""
                    }]
                },
                {
                    "topic_id": 57,
                    "id": 57,
                    "type_id": 4,
                    "typenm": "简答题",
                    "shorttag": "",
                    "showway": "",
                    "topic_score": "8.00",
                    "isauto": 0,
                    "info": "",
                    "km": "",
                    "stem_url": "",
                    "audiofile": "",
                    "audiofile_suffix": "",
                    "audiofile_title": "附件下载",
                    "is_collect": 0,
                    "status": 0,
                    "is_play": 0,
                    "issign": 0,
                    "isok": 0,
                    "isdone": 0,
                    "getscore": 0,
                    "comment": "",
                    "ischeck": 0,
                    "ps_info": "根据相关要求，完成下列题目。",
                    "topic_sub": [{
                        "shorttag": "",
                        "direction": 0,
                        "type_id": 4,
                        "typenm": "简答题",
                        "score": "8.00",
                        "topic_id": 57,
                        "sub_id": 1,
                        "isauto": 0,
                        "is_upload": 0,
                        "para44_id": 0,
                        "upload_explain": "",
                        "options": [],
                        "showway": "",
                        "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">2 <\/span>Which period did Qu Yuan live in?<\/span><\/p>",
                        "subanalysis": "",
                        "sortid": 1,
                        "file_name": "",
                        "user_answer": [],
                        "brief_answer": {},
                        "user_status": -1,
                        "answer_img": {},
                        "topic_answer": [{
                            "topic_id": 57,
                            "sub_id": 1,
                            "sortid": 1,
                            "ask": "",
                            "answer": "",
                            "askend": null,
                            "answer_id": 1,
                            "answer_url": "",
                            "answertitle": null,
                            "score": "8.00",
                            "operation_score": 0
                        }],
                        "video_list": [],
                        "isok": 0,
                        "isdone": 0,
                        "concat_answer": "",
                        "user_concat_answer": ""
                    }]
                },
                {
                    "topic_id": 57,
                    "id": 57,
                    "type_id": 4,
                    "typenm": "简答题",
                    "shorttag": "",
                    "showway": "",
                    "topic_score": "8.00",
                    "isauto": 0,
                    "info": "",
                    "km": "",
                    "stem_url": "",
                    "audiofile": "",
                    "audiofile_suffix": "",
                    "audiofile_title": "附件下载",
                    "is_collect": 0,
                    "status": 0,
                    "is_play": 0,
                    "issign": 0,
                    "isok": 0,
                    "isdone": 0,
                    "getscore": 0,
                    "comment": "",
                    "ischeck": 0,
                    "ps_info": "根据相关要求，完成下列题目。",
                    "topic_sub": [{
                        "shorttag": "",
                        "direction": 0,
                        "type_id": 4,
                        "typenm": "简答题",
                        "score": "8.00",
                        "topic_id": 57,
                        "sub_id": 1,
                        "isauto": 0,
                        "is_upload": 0,
                        "para44_id": 0,
                        "upload_explain": "",
                        "options": [],
                        "showway": "",
                        "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">3 <\/span>What is Qu Yuan known for?<\/span><\/p>",
                        "subanalysis": "",
                        "sortid": 1,
                        "file_name": "",
                        "user_answer": [],
                        "brief_answer": {},
                        "user_status": -1,
                        "answer_img": {},
                        "topic_answer": [{
                            "topic_id": 57,
                            "sub_id": 1,
                            "sortid": 1,
                            "ask": "",
                            "answer": "",
                            "askend": null,
                            "answer_id": 1,
                            "answer_url": "",
                            "answertitle": null,
                            "score": "8.00",
                            "operation_score": 0
                        }],
                        "video_list": [],
                        "isok": 0,
                        "isdone": 0,
                        "concat_answer": "",
                        "user_concat_answer": ""
                    }]
                },

                ],
                completeType: '', // 答题完成后的操作 statistics：展示统计结果
            },

        ],
    },
    // 模板样式 单个带边框
    {
        key: 'section1.10',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [

            {
                key: 'section1.10.1',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'II',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },
                    popContent: { // 气泡
                        key: 'section1.10.1.0', // *必填* 唯一标识
                        category: 'popover', // *必填* 内容类型 text：文本
                        // text: '轴线', // *必填* 文本内容
                        textSlot: 1, // 是否以插槽方式引入内容
                        // popTitle: '轴线的名词解释',
                        popText: '',
                        content: [{
                            key: 'section1.9.2.1.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '参考答案', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Activities', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.3', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.3.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '1. dragon boat races', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.4', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.4.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '2. performances', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.5', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.5.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '3. door', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.6', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.6.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Food', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.7', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.7.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '1. bamboo leaves', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.9.2.1.8', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.9.2.1.8.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '2. beans;meat', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },

                        ],
                        textStyle: {

                        },
                    },
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.10.1.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.10.1.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Listen to the dialogue again and fill in the blanks below.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 50,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.10.2',
                type: 'ulflex',
                category: 1, 
                inputtype:true,
                templateStyle: {
                    padding: 0,
                    backgroundColor: '#FFFFFF'
                },
                content:[
                    {
                        key: 'section1.10.2.1',
                        type: 'flextext',
                        category: '',
                        text:'Activities',
                        list:[
                            {
                                key: 'section1.10.2.1.1',
                                text:'1. Watch',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                },
                                listitem:[
                                    {
                                        key: 'section1.10.2.1.1.1',
                                        text:'1. Watch ',
                                    },
                                    {
                                        key: 'section1.10.2.1.1.2',
                                        text:'',
                                        category:'input',
                                    },
                                    {
                                        key: 'section1.10.2.1.1.3',
                                        text:' and cheer for the teams.',
                                    }
                                ]
                            },
                            {
                                key: 'section1.10.2.1.2',
                                text:'',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                },
                                listitem:[
                                    {
                                        key: 'section1.10.2.1.2.1',
                                        text:'2. Enjoy traditional ',
                                    },
                                    {
                                        key: 'section1.10.2.1.2.2',
                                        text:'',
                                        category:'input',
                                    },
                                    {
                                        key: 'section1.10.2.1.2.3',
                                        text:', such as stilt walking.',
                                    }
                                ]
                            },
                            {
                                key: 'section1.10.2.1.3',
                                text:'',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                },
                                listitem:[
                                    {
                                        key: 'section1.10.2.1.3.1',
                                        text:'3. Hang wormwood leaves on the ',
                                    },
                                    {
                                        key: 'section1.10.2.1.3.2',
                                        text:'',
                                        category:'input',
                                    },
                                    {
                                        key: 'section1.10.2.1.3.3',
                                        text:'.',
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        key: 'section1.10.2.2',
                        type: 'flextext',
                        category: '',
                        text:'Food',
                        list:[
                            {
                                key: 'section1.10.2.2.1',
                                text:'1. Watch',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                },
                                listitem:[
                                    {
                                        key: 'section1.10.2.2.1.1',
                                        text:'1. Eat zongzi, a delicious rice dumpling wrapped in ',
                                    },
                                    {
                                        key: 'section1.10.2.2.1.2',
                                        text:'',
                                        category:'input',
                                    },
                                    {
                                        key: 'section1.10.2.2.1.3',
                                        text:'.',
                                    },
                                ]
                            },
                            {
                                key: 'section1.10.2.2.2',
                                text:'',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                },
                                listitem:[
                                    {
                                        key: 'section1.10.2.2.2.1',
                                        text:'2. Zongzi is filled with various ingredients, such as ',
                                    },
                                    {
                                        key: 'section1.10.2.2.2.2',
                                        text:'',
                                        category:'input',
                                    },
                                    {
                                        key: 'section1.10.2.2.2.3',
                                        text:' and ',
                                    },
                                    {
                                        key: 'section1.10.2.2.2.4',
                                        text:'',
                                        category:'input',
                                    },
                                    {
                                        key: 'section1.10.2.2.2.5',
                                        text:'.',
                                    },
                                ]
                            },
                        ]
                    },
                ]
            }

        ],
    },
    {
        key: 'section1.11',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "After You Listen", // *必填* 标题文本内容
        titleImageType: 1,
        titleImage: require("@/assets/images/books/book2/title-icon1.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 20, // 首行缩进  标题前带图标的写30，不带图标的写20
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            marginLeft: 20,
            paddingRight: 20,
            margin: 24,
            marginTop: 20,
            marginBottom: 0,

        },

    },
    // 模板样式 单个带边框
    {
        key: 'section1.12',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [

            {
                key: 'section1.12.1',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'I',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.1.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.1.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Read the dialogue and learn the expressions about the Dragon Boat Festival.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.2',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: ' Mike: ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.2.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.2.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Hey, Pia, any plans for the weekend?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.3',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: ' Pia: ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.3.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.3.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Hey, Mike! I’m going home to celebrate the ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.3.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'Dragon Boat Festival.', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            word_url: require('@/assets/audio/2-4/01Dragon Boat Festival.mp3'), // 单词音频,
                            popWord: true,
                            isPlay: false,
                            popWordTitle: [{
                                key: 'section1.12.3.1.2.1',
                                text: 'Dragon Boat Festival',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.3.1.2.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [
                                {
                                    key: 'section1.12.3.1.2.88',
                                    text: '',
                                    textStyle: {
                                        fontFamily: 'STXihei',
                                        color: '#333',
                                        fontSize: 14
                                    },
                                    content: [{
                                        key: 'section1.12.3.1.2.88.1',
                                        text: '',
                                        // textFlex:true,
                                        textStyle: {},
                                        content: [{
                                            key: 'section1.12.3.1.2.88.1.1',
                                            text:'端午节，为每年农历五月初五，又称端阳节、午日节、五月节等。端午节是中国汉族人民纪念人民纪念屈原的的传统节日，有吃粽子，赛龙舟，挂莒蒲、蒿草、艾叶，薰苍术、白芷，喝雄黄酒的习俗。“端午节”为国家法定节假日法定节假日之一，并列入世界非物质文化遗产名录。',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                            },
                                        },
                                     
                                        ]
                                    },
                             
                                ]
                                },{
                                key: 'section1.12.3.1.2.4',
                                text: '英语话端午',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.3.1.2.4.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.4.1.1',
                                        text: 'The Dragon Boat Festival is a traditional and statutory holiday in China.',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.41.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.41.1.2',
                                        text: '端午节是中国传统的、法定节日。',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.5.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.5.1.1',
                                        text: 'The Dragon Boat Festival is established to commemorate the patriotic poet, Qu Yuan.',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.51.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.51.1.2',
                                        text: '端午节是为了纪念爱国诗人屈原。',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.6.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.6.1.1',
                                        text: 'Dragon boat racing is an indispensable part of the festival, held all over the country.',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.61.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.61.1.2',
                                        text: '賽龙舟是端午节的主要习俗，全国各地都在举行。',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.7.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.7.1.1',
                                        text: 'make/wrap zongzi  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.3.1.2.7.1.2',
                                        text: '包粽子',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.8.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.8.1.1',
                                        text: 'drink realgar wine  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.3.1.2.8.1.2',
                                        text: '饮雄黄酒',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.9.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.9.1.1',
                                        text: 'hold a dragon boat race  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.3.1.2.9.1.2',
                                        text: '赛龙舟',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                                {
                                    key: 'section1.12.3.1.2.10.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.3.1.2.10.1.1',
                                        text: 'commemorate/in honour of Qu Yuan  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.3.1.2.10.1.2',
                                        text: '纪念屈原',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },
                            ]
                            },
                            
                        ],
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },

                        },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.4',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.4.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.4.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Great! I’ve never celebrated it before. What’s the festival about?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.5',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.5.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.5.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'It is ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.5.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'in memory of', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/02in memory of.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.5.1.2.1',
                                text: 'in memory of',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.5.1.2.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [{
                                key: 'section1.12.5.1.2.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.5.1.2.3.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.5.1.2.3.1.1',
                                        text: 'as a way of remembering someone who has died  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.5.1.2.3.1.2',
                                        text: '为纪念（某人），用来表达对某人或某事的怀念，通常用于悼念或追思的场合，以表示对逝者的尊重和缅怀。',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },]
                            },
                            {
                                key: 'section1.12.5.1.2.4',
                                text: '例句',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    // fontSize: 14
                                },
                                content: [
                                    {
                                        key: 'section1.12.5.1.2.4.1',
                                        text: '',
                                        textFlex: true,
                                        textStyle: {
                                        },
                                        content: [
                                            // 
                                            {
                                                key: 'section1.12.5.1.2.4.1.1',
                                                text: 'e.g. ',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.12.5.1.2.4.1.2',
                                                text: 'There is a tablet in memory of those who died.',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.12.5.1.2.4.1.3',
                                                text: '那儿有一块碑纪念死去的人。',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 13,
                                                    // lineHeight: 36,
                                                },
                                            },
                                        ]
                                    },
                                ]
                            },

                            ],
                        },
                        {
                            key: 'section1.12.5.1.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: ' the ancient poet ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                        },
                        {
                            key: 'section1.12.5.1.4', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'Qu Yuan', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/04Qu Yuan.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.5.1.4.1',
                                text: 'Qu Yuan',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            ],
                            popWordList: [
                                {
                                    key: 'section1.12.5.1.4.2',
                                    text: '',
                                    textStyle: {
                                        fontFamily: '宋体',
                                        color: '#333',
                                        // fontSize: 14
                                    },
                                    content: [
                                        {
                                            key: 'section1.12.5.1.4.2.1',
                                            text: '',
                                            // textFlex:true,
                                            textStyle: {
                                            },
                                            content: [
                                                {
                                                    key: 'section1.12.5.1.4.2.1.1',
                                                    text: '屈原（约公元前',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        // fontSize: 13,
                                                        // lineHeight: 36,
                                                    },
                                                },
                                                {
                                                    key: 'section1.12.5.1.4.2.1.2',
                                                    text: '340',
                                                    textStyle: {
                                                        fontFamily: 'Times New Roman',
                                                        color: '#333',
                                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.12.5.1.4.2.1.3',
                                                    text: '-公元前',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        // fontSize: 13,
                                                        // lineHeight: 36,
                                                    },
                                                },
                                                {
                                                    key: 'section1.12.5.1.4.2.1.4',
                                                    text: '278',
                                                    textStyle: {
                                                        fontFamily: 'Times New Roman',
                                                        color: '#333',
                                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.12.5.1.4.2.1.5',
                                                    text: '年），名平，字原，又名正则，字灵均。战国时代楚国人。他主张选拔德才兼备的人出任官职，以实现富国强兵的理想，但朝中贵族竭力反对、毁谤和打击他，后来被长期流放沅江和湘江一带，最后绝望投江而死。屈原是中国最早的伟大诗人。他的诗作语言优美，想象丰富，对后世影响很大。代表作品有《离骚》等。',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        // fontSize: 13,
                                                        // lineHeight: 36,
                                                    },
                                                },
                                            ]
                                        },
                                    ]
                                },

                            ],
                        },
                        {
                            key: 'section1.12.5.1.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: ' also a day to ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                        },
                        {
                            key: 'section1.12.5.1.6', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'ward off', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/03ward off.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [
                                {
                                    key: 'section1.7.2.3.2.1',
                                    text: 'ward off',
                                    textStyle: {
                                        fontFamily: 'Arial',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        // fontSize: 18,
                                    }
                                },
                            ],
                            popWordList: [{
                                key: 'section1.12.5.1.2.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.5.1.2.3.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.5.1.2.3.1.1',
                                        text: 'to keep someone or something away or prevent something from happening or harming you  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.5.1.2.3.1.2',
                                        text: '避开；阻止；挡住',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },]
                            },
                            {
                                key: 'section1.7.2.3.2.4',
                                text: '例句',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                },
                                content: [
                                    {
                                        key: 'section1.7.2.3.2.4.1',
                                        text: '',
                                        textFlex: true,
                                        textStyle: {
                                        },
                                        content: [
                                            // 
                                            {
                                                key: 'section1.7.2.3.2.4.1.1',
                                                text: 'e.g. ',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.1.2',
                                                text: 'In the winter I take vitamin C to ward off colds.',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.1.3',
                                                text: '冬天我服用维生素C以预防感冒。',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 13,
                                                    // lineHeight: 36,
                                                },
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.1.2',
                                                text: 'She was given a magic charm to ward off evil spirits.',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.1.3',
                                                text: '她得到了一个魔法护身符，可以驱鬼避邪。',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 13,
                                                    // lineHeight: 36,
                                                },
                                            },
                                        ]
                                    },
                                ]
                            },

                            ],

                        },
                        {
                            key: 'section1.12.5.1.7', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'bad luck, disease, etc.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                        },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.6',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.6.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.6.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Who’s Qu Yuan?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.7',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.7.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.7.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'He was a Chinese poet and ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.7.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'aristocrat', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/05aristocrat.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.7.1.2.1',
                                text: 'aristocrat',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.7.1.2.2',
                                text: '/ˈærɪstəkræt/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [
                                {
                                    key: 'section1.12.7.1.2.3',
                                    text: '释义',
                                    textStyle: {
                                        fontFamily: 'STXihei',
                                        color: '#333',
                                        // fontSize: 14
                                    },
                                    content: [
                                        {
                                            key: 'section1.12.7.1.2.3.1',
                                            text: '',
                                            // textFlex: true,
                                            textStyle: {
                                            },
                                            content: [
                                                // 
                                                {
                                                    key: 'section1.12.7.1.2.3.1.1',
                                                    text: 'n. ',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.12.7.1.2.3.1.2',
                                                    text: 'a person of high social rank who belongs to the aristocracy  ',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.12.7.1.2.3.1.3',
                                                    text: '贵族（成员）',
                                                    textStyle: {
                                                        fontFamily: 'STXihei',
                                                        color: '#333',
                                                        // fontSize: 13,
                                                        // lineHeight: 36,
                                                    },
                                                },
                                            ]
                                        },
                                    ]
                                },

                            ],
                        },
                        {
                            key: 'section1.12.7.1.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: ' in the State of Chu during the Warring States Period. He is known for his ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                        },
                        {
                            key: 'section1.12.7.1.4', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'patriotism', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/06patriotism.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.7.1.4.1',
                                text: 'patriotism',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.7.1.4.2',
                                text: '/ˈpætriəˌtɪz(ə)m/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [{
                                key: 'section1.12.7.1.4.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.7.1.4.3.1',
                                    text: '',
                                    // textFlex: true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.7.1.4.3.1.1',
                                        text: 'n. ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        },
                                    },
                                    {
                                        key: 'section1.12.7.1.4.3.1.2',
                                        text: 'the feeling of loving your country more than any others and being proud of it  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.7.1.4.3.1.3',
                                        text: '爱国主义 ',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },]
                            },
                            ],
                        },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.8',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.8.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.8.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'So, what do you usually do on that day?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.9',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.9.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.9.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Well, we usually watch dragon boat races and cheer for the teams.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.7.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'aristocrat', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },


                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.10',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.10.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.10.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Wow, it would be exciting to see the dragon boats racing on the water.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.11',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.11.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.11.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Sure it is. Additionally, some places also have traditional performances, such as ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.11.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'stilt walking    ', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/07stilt walking.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.11.1.2.1',
                                text: 'stilt walking',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            ],
                            popWordList: [{
                                key: 'section1.12.11.1.2.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.11.1.2.2.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.11.1.2.2.1.1',
                                        text: '踩高跷，也称“高跷秧歌”，是一种历史悠久的民间舞蹈，广泛流传于全国各地，因表演时多用双脚踩踏木跷而得名。高跷一般以舞队的形式表演，参演者十数人至数十人不等，多扮演古代神话或历史故事中的人物，服饰多模仿戏曲行头，演出中常用的道具包括扇子、手绢、木棍、刀枪等。高跷有“踩街”和“撂场”两种表演形式，其中“撂场”又分“大场”和“小场”两种。“大场”由舞队集体表演，边舞边走各种队形图案；“小场”由两三人表演，多为男女对舞，有时边舞边唱。各地高跷所用木跷从',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.11.1.2.2.1.2',
                                        text: '30',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.11.1.2.2.1.3',
                                        text: '厘米至',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.11.1.2.2.1.4',
                                        text: '300',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.11.1.2.2.1.5',
                                        text: '厘米不等，根据表演风格又可分为“文跷”和“武跷”两种，文跷重扭踩和情节表演，武跷则重炫技表演。经过几千年的发展，踩高跷在风格上有很大的提高，已成为中国节日文化的重要组成部分。',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },]
                            },
                            ],
                        },


                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.12',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.12.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.12.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'That sounds ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.12.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'incredible', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/08incredible.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.12.1.2.1',
                                text: 'incredible',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.12.1.2.2',
                                text: '/ɪnˈkredəbl/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [{
                                key: 'section1.12.12.1.2.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.12.1.2.3.1',
                                    text: '',
                                    // textFlex: true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.12.1.2.3.1.1',
                                        text: 'adj. ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        },
                                    },
                                    {
                                        key: 'section1.12.12.1.2.3.1.2',
                                        text: 'impossible, or very difficult, to believe  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.12.1.2.3.1.3',
                                        text: '不可思议的；惊人的；难以置信的；未必可能的',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },]
                            },
                            ],
                        },
                        {
                            key: 'section1.12.12.1.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '! Are there any other activities ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.12.1.4', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'associated with', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/09associate with.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.5.1.2.1',
                                text: 'associated with',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.5.1.2.2',
                                text: '/əˈsəuʃieit wið/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [{
                                key: 'section1.12.5.1.2.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.5.1.2.3.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.5.1.2.3.1.1',
                                        text: '与',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.5.1.2.3.1.2',
                                        text: '……',
                                        textStyle: {
                                            fontFamily: '宋体',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.5.1.2.3.1.3',
                                        text: '联系；和',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.5.1.2.3.1.4',
                                        text: '……',
                                        textStyle: {
                                            fontFamily: '宋体',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.5.1.2.3.1.5',
                                        text: '来往',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },

                                    ]
                                },]
                            },
                            {
                                key: 'section1.12.5.1.2.4',
                                text: '例句',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    // fontSize: 14
                                },
                                content: [
                                    {
                                        key: 'section1.12.5.1.2.4.1',
                                        text: '',
                                        textFlex: true,
                                        textStyle: {
                                        },
                                        content: [
                                            // 
                                            {
                                                key: 'section1.12.5.1.2.4.1.1',
                                                text: 'e.g. ',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.12.5.1.2.4.1.2',
                                                text: 'What do you associate with such a heavy snow?',
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    color: '#333',
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // fontSize: 13,
                                                    // lineHeight: 36
                                                },
                                            },
                                            {
                                                key: 'section1.12.5.1.2.4.1.3',
                                                text: '这样一场大雪你有什么联想? ',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 13,
                                                    // lineHeight: 36,
                                                },
                                            },
                                        ]
                                    },
                                ]
                            },

                            ],
                        },
                        {
                            key: 'section1.12.12.1.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'the festival?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.13',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.13.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.13.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Yes. One popular activity is hanging ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.13.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: 'wormwood', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/10wormwood.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.13.1.2.1',
                                text: 'wormwood',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.13.1.2.2',
                                text: '/ˈwɜːmwʊd/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [{
                                key: 'section1.12.13.1.2.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.13.1.2.3.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section1.12.13.1.2.3.1.1',
                                        text: 'n. ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // fontSize: 13,
                                            // lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section1.12.13.1.2.3.1.2',
                                        text: 'one of several kinds of artemisia (= a family of bushes and plants with a strong smell and a bitter taste), some of which are used in medicines  ',
                                        textStyle: {
                                            fontFamily: 'Calibri',
                                            color: '#333',
                                        },
                                    },
                                    {
                                        key: 'section1.12.13.1.2.3.1.3',
                                        text: '蒿；苦艾',
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                        },
                                    },
                                    ]
                                },]
                            },
                            ],
                        },
                        {
                            key: 'section1.12.13.1.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'leaves on the door.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },


                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.14',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.14.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.14.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'That would be fun. What about the food?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.15',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.15.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.15.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'We eat zongzi, which is a delicious rice dumpling', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.15.1.2', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: ' wrapped ', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/11wrap.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.5.1.2.1',
                                text: 'wrap',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.5.1.2.2',
                                text: '/ræp/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [{
                                key: 'section1.12.5.1.2.3',
                                text: '释义',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section1.12.5.1.2.4.1',
                                    text: '',
                                    // textFlex: true,
                                    textStyle: {
                                    },
                                    content: [
                                        // 
                                        {
                                            key: 'section1.12.5.1.2.4.1.1',
                                            text: 'v. ',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#333',
                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                // fontSize: 13,
                                                // lineHeight: 36
                                            },
                                        },
                                        {
                                            key: 'section1.12.5.1.2.4.1.2',
                                            text: 'to cover or surround something with paper, cloth, or other material  ',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#333',
                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                // fontSize: 13,
                                                // lineHeight: 36
                                            },
                                        },
                                        {
                                            key: 'section1.12.5.1.2.4.1.3',
                                            text: '包；裹',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                // fontSize: 13,
                                                // lineHeight: 36,
                                            },
                                        },
                                    ]
                                },]
                            },
                            ],
                        },
                        {
                            key: 'section1.12.15.1.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: ' in bamboo leaves and filled with various', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        {
                            key: 'section1.12.15.1.4', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: ' ingredients ', // *必填* 文本内容
                            popTitle: '',
                            popText: '',
                            popWord: true,
                            isPlay: false,
                            word_url: require('@/assets/audio/2-4/12ingredient.mp3'), // 单词音频,
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体
                            },
                            popWordTitle: [{
                                key: 'section1.12.5.1.2.1',
                                text: 'ingredient',
                                textStyle: {
                                    fontFamily: 'Arial',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: 18,
                                }
                            },
                            {
                                key: 'section1.12.5.1.2.2',
                                text: '/ɪnˈɡriːdiənt/',
                                textStyle: {
                                    fontFamily: 'Calibri',
                                    color: '#999999',
                                    fontSize: 14,
                                }
                            }
                            ],
                            popWordList: [
                                {
                                    key: 'section1.7.2.3.2.4',
                                    text: '例句',
                                    textStyle: {
                                        fontFamily: 'STXihei',
                                        color: '#333',
                                        // fontSize: 14
                                    },
                                    content: [
                                        {
                                            key: 'section1.7.2.3.2.4.1',
                                            text: '',
                                            // textFlex: true,
                                            textStyle: {
                                            },
                                            content: [
                                                // 
                                                {
                                                    key: 'section1.7.2.3.2.4.1.1',
                                                    text: 'n. ',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.1.2',
                                                    text: 'something that enters into a compound or is a component part of any combination or mixture  ',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.1.3',
                                                    text: '成分；要素；（尤指烹饪）材料',
                                                    textStyle: {
                                                        fontFamily: 'STXihei',
                                                        color: '#333',
                                                        // fontSize: 13,
                                                        // lineHeight: 36,
                                                    },
                                                },
                                            ]
                                        },
                                    ]
                                },

                            ],
                        },
                        {
                            key: 'section1.12.15.1.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: ', such as beans and meat.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },

                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.16',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.16.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.16.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'That sounds delicious! I’d love to try zongzi someday. ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.17',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.17.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.17.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Would you like to join me and my family for the festivities?', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.7.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'aristocrat', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },


                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.18',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Mike:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#5CA683', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.18.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.18.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'I’d love to. Thank you for inviting me. I’m really looking forward to celebrating this festival in China.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.3.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'Dragon Boat Festival.', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section1.12.19',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: '  Pia:  ',
                    textStyle: {
                        fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.12.19.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.12.19.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'You’re welcome, Mike! I’m sure you’ll have a wonderful time.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                        // {
                        //     key: 'section1.12.7.1.2', // *必填* 唯一标识
                        //     category: 'popover', // *必填* 内容类型 text：文本
                        //     text: 'aristocrat', // *必填* 文本内容
                        //     popTitle: '',
                        //     popText: '',
                        //     textStyle: {
                        //         fontFamily: 'Calibri', // 字体，本地配置的字体
                        //     },
                        // },


                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
        ],
    },
    // 模板样式 单个带边框
    {
        key: 'section1.13',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [

            {
                key: 'section1.13.1',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'II',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.13.1.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.13.1.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Practice the dialogue and perform it with your partner.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 50,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },


        ],
    },
    // 小标题
    {
        key: 'section1.14',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Speak and Perform", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/SpeakandPerform.png"),
        titleImageWidth: 524,
        titleImagePosition: 'left',
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 36, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 112, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section1.15', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'Make a dialogue with your partner on one of the topics below, and then perform it in front of your classmates.', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'ArialMT', // 字体，本地配置的字体
                    fontSize: device.isMobile ? 28 : 20, // 文字大小  默认：20
                    fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section1.16',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Topic 1", // *必填* 标题文本内容
        titleImageType: 2,
        titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 28, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            margin: 24,
            marginTop: 20,
            marginBottom: 0,
            borderRadius: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 48,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
    },
    // 模板样式 单个带边框
    {
        key: 'section1.17',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [
            //正文
            {
                key: 'section1.17.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.17.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'The Spring Festival holds great significance in China as it is considered the most important festival and symbolizes reunion and new beginnings. People participate in various activities to celebrate this festival. Discuss with your partner what your usual activities are during the Spring Festival, as well as your overall feelings about it. The following information is for your reference.', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            

                        },
                    },
                ],
                textStyle: {
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },

            },
            // 视频
            {
                key: 'section1.17.2', // *必填* 唯一标识
                type: 'video', // *必填* 类型：视频
                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                playerInline: 1, // 是否是行内播放 1：行内播放
                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                content: [ // *必填* 视频列表
                    {
                        key: 'section1.17.2.1.1', // *必填* 唯一标识
                        url: require("@/assets/video/book2/2-5 如何过春节.mp4"), // *必填* 视频地址
                        left_img:  require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                        title: '2-5 如何过春节', // 视频标题
                        subtitle: '2-5 如何过春节', // 视频副标题 只在全部显示时使用
                        titleStyle: {
                            // 根据需要是否加标题样式
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            // padding: 20,
                            // margin: 20
                            padding: 20,
                            paddingTop: 0,
                            paddingBottom: 0,
                        }
                    },
                ],
                // textStyle: {
                //     // fontFamily: 'xxx', // 字体，本地配置的字体
                //     // fontSize: 20, // 文字大小  默认：20
                //     // lineHeight: 40, // 行高  默认：36
                //     // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                //     // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                //     // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                //     // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                //     // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                //     color: '#333', // 文本颜色  默认：#00a8ac
                //     // backgroundColor: '#FFF', // 背景颜色  默认：无
                //     padding: 20,
                //     margin: 20
                // },
            },
            {
                key: 'section1.17.3',
                type: 'ulflex',
                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                templateStyle: {
                    padding: 0,
                    backgroundColor: '#FFFFFF'
                },
                content:[
                    {
                        key: 'section1.17.3.1',
                        type: 'flextext',
                        category: '',
                        width:50,
                        text:'Activities',
                        list:[
                            {
                                key: 'section1.17.3.1',
                                text:'clean the house',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2',
                                text:'put up couplets',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.3',
                                text:'paste “Fu” on the window',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.4',
                                text:'decorate the house',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.5',
                                text:'help parents cook dinner',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.6',
                                text:'make dumplings',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.7',
                                text:'have a big dinner',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.8',
                                text:'watch the Spring Festival Gala',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.9',
                                text:'visit relatives and friends',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.10',
                                text:'get red packets',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.11',
                                text:'play firecrackers',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.12',
                                text:'go traveling',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            }
                        ]
                    },
                    {
                        key: 'section1.17.3.2',
                        type: 'flextext',
                        category: '',
                        width:25,
                        text:'Feelings',
                        list:[
                            {
                                key: 'section1.17.3.2.1',
                                text:'interesting',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.2',
                                text:'fantastic',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.3',
                                text:'unforgettable',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.4',
                                text:'wonderful',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.5',
                                text:'amazing',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.6',
                                text:'memorable',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.7',
                                text:'joyful',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            },
                            {
                                key: 'section1.17.3.2.8',
                                text:'special',
                                textStyle:{
                                    color:"#333",
                                    fontSize:26,
                                    fontFamily: 'Times New Roman'
                                }
                            }
                        ]
                    }
                ]
             
            },
            // {
            //     key: 'section1.17.3',
            //     type: "title",
            //     category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
            //     // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
            //     text: "Sentences for reference", // *必填* 标题文本内容
            //     titleImageType: 3,
            //     // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
            //     textStyle: {
            //         fontFamily: 'Arial', // 字体，本地配置的字体
            //         fontSize: 26, // 文字大小  默认：26
            //         height: 49,
            //         width: 'auto',
            //         lineHeight: 49, // 行高  默认：46
            //         maxWidth: 500,
            //         margin: 20,
            //         // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
            //         // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            //         // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            //         // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            //         // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            //         color: '#fff', // 文本颜色  默认：#00a8ac
            //         backgroundColor: '#5CA683', // 背景颜色  默认：无
            //         // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            //         borderRadius: {
            //             borderTopLeftRadius: 20,
            //             borderTopRightRadius: 0,
            //             borderBottomRightRadius: 20,
            //             borderBottomLeftRadius: 0
            //         }
            //     },
            // },
            {
                key: 'section1.17.4',
                type: "title",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "Sentences for reference", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 30, // 行高  默认：46
                    maxWidth: 500,
                    margin: 24,
                    marginBottom: -130,
                    // marginLeft: 20,
                    // paddingLeft: 20,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },
            // 模板样式 单个带边框
            {
                key: 'section1.17.5',
                type: 'template',
                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,


                    padding:34,
                    marginTop: -20,

                    backgroundColor: '#F0F8F5',
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    borderRadius: 10,
                    border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                content: [

                    // 列表
                    {
                        key: 'section1.17.5.1', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.1.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.1.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'How was your last Spring Festival?', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.17.5.2', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.2.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.2.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'How did you spend your last Spring Festival?', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.17.5.3', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.3.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.3.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'What do you usually do during the Spring Festival?', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.17.5.4', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.4.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.4.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'Is there anything special?', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.17.5.5', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.5.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.5.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'What impressed you the most?', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.17.5.6', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.6.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.6.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'It’s a family get-together.', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.17.5.7', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.17.5.7.1.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.17.5.7.1.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'It symbolizes/stands for…', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },



                ],
            },
            {
                key: 'section1.17.6',
                type: "sound",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 49, // 行高  默认：46
                    maxWidth: 500,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },


        ],
    },
    {
        key: 'section1.18',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Topic 2", // *必填* 标题文本内容
        titleImageType: 2,
        titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 28, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            margin: 24,
            marginTop: 20,
            marginBottom: 0,
            borderRadius: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 48,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
    },
    // 模板样式 单个带边框
    {
        key: 'section1.19',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [
            //正文
            {
                key: 'section1.19.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.19.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'What’s your favorite festival? Talk about it with your partner. The following information is for your reference.', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },
            },
            {
                key: 'section1.19.2',
                type: "title",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "The following aspects of a festival can be included in your dialogue", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    // height: 49,
                    paddingTop:15,
                    paddingBottom:15,
                    width: 'auto',
                    lineHeight: 32, // 行高  默认：46
                    maxWidth: 500,
                    // marginLeft: 20,
                    // paddingLeft: 20,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    margin: 24,
                    marginBottom: -120,
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },
            // 模板样式 单个带边框
            {
                key: 'section1.19.3',
                type: 'template',
                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    padding: 34,
                    marginTop: -35,
                    backgroundColor: '#F0F8F5',
                    paddingTop: 60,
                    // paddingBottom: 0,
                    borderRadius: 10,
                    border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                content: [

                    // 列表
                    {
                        key: 'section1.19.3.1', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.19.3.1.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.19.3.1.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'time', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.19.3.2', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.19.3.2.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.19.3.2.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'origin', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.19.3.3', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.19.3.3.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.19.3.3.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'significance and meaning ', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.19.3.4', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.19.3.4.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.19.3.4.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'customs and traditions', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.19.3.5', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.19.3.5.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.19.3.5.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'personal connection (the reason why this holiday is your favorite)', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },
                    // 列表
                    {
                        key: 'section1.19.3.6', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section1.19.3.6.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,

                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.19.3.6.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'personal enjoyment (the activities you personally enjoy during the holiday)', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },

                                    },
                                ],

                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },

                            },
                        ],

                    },

                ],
            },
            //展开收起title
            {
                key: 'section1.19.4',
                type: 'template',
                category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    // padding: 0,
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                title: 'Sample',
                titleStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    marginTop: 20,
                    // marginBottom: 30,
                    // padding: 0,
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                content: [
                    {
                        key: 'section1.19.4.1',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'What’s your favorite festival?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 20,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.3',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.4.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'My favorite festival is...', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.6',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.6.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.6.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'When does... take place and why is it celebrated?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.7',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.7.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.7.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'This festival usually falls in... It is a celebration of...', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.8',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.8.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.8.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'That sounds lovely! Are there any unique customs and traditions associated with this festival?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.9',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.9.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.9.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Yes. One of the main customs is... People always...', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.10',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.10.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.10.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Is there a personal connection that makes it your favorite?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.11',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.11.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.11.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Yes, definitely! It’s special for me because...', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.12',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.12.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.12.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'What do you enjoy the most about this festival?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.13',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.13.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.13.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'The feeling of unity and the joy of celebrating it with loved ones make it truly special for me.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.14',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.14.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.14.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'That sounds amazing! I see why it is your favorite festival and thank you for sharing all these wonderful aspects of it with me.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.19.4.15',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.19.4.15.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.19.4.15.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'You’re welcome!', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 30,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                ],
                contentStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    padding: 20,
                    paddingTop: 0,
                    paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
            },
            {
                key: 'section5',
                type: "sound",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 49, // 行高  默认：46
                    maxWidth: 500,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },


        ],
    },
    {
        key: 'section1.20',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Topic 3", // *必填* 标题文本内容
        titleImageType: 2,
        titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 28, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            margin: 24,
            marginTop: 20,
            marginBottom: 0,
            borderRadius: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 48,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
    },
    // 模板样式 单个带边框
    {
        key: 'section1.21',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 0,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [
            //正文
            {
                key: 'section1.21.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.21.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'As the Dragon Boat Festival is approaching, your class has made plans to organize a party to celebrate it. You would like to invite your best friend to join you for this event. The following information is for your reference.', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },

            },
            // 图片
            {
                key: 'section1.21.2', // *必填* 唯一标识
                type: 'image', // *必填* 类型：正文
                // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
                // cover: require("@/assets/images/bookContent/single_video.png"),
                // noMargin: 1,
                content: [ // *必填* 图片列表
                    {
                        key: 'section1.21.2.1', // *必填* 唯一标识
                        url: require("@/assets/images/books/book2/content-img-1.png"), // *必填* 图片地址
                        // title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-10<\/i>  尺寸线", // 图片标题
                        // hasBack: 1,
                        // titlePosition: 'top', // 标题位置， 默认为bottom
                        heightNoLimit: 1,
                        titleStyle: {

                        }
                    }
                ],
            },
            //展开收起title
            {
                key: 'section1.22.4',
                type: 'template',
                category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    marginTop: 20,
                    // marginBottom: 30,
                    // padding: 0,
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                title: 'Sample',
                titleStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    // padding: 0,
                    //paddingTop: 0,
                    //paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                content: [
                    {
                        key: 'section1.22.4.1',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Hey, guess what? Our class has decided to organize a Dragon Boat Festival party at 6:00 p.m. this Saturday, and I really want you to be there!', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 20,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.3',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.4.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'That sounds like a lot of fun! What’s the plan for the party?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.5',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.5.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.5.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'We’ll have a variety of activities. We can... And of course, we’ll...', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.6',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.6.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.6.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'That sounds amazing! Where will the party be held?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.7',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.7.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.7.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'The party will take place at...', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.8',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.8.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.8.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Who will attend the party?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.9',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.9.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.9.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Not only... but also... are welcome to our party. ', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.10',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.10.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.10.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Any special requirements for the party?', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.11',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.11.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.11.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'Yes, there is one. We’re suggesting that... It will make the celebration even more special.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.12',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.12.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.12.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'I’m really excited about this! I’d like to go!', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.13',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' A: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#5CA683', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.13.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.13.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'That’s great to hear! See you then!', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                }
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 10,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                    {
                        key: 'section1.22.4.14',
                        type: 'paragraph',
                        category: 'withBefore',
                        leftMark: { // 左侧标记
                            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                            width: 55,
                            height: 40,
                            text: ' B: ',
                            textStyle: {
                                fontFamily: 'Calibri-Italic', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                paddingLeft: 0,
                                paddingRight: 15,
                                marginLeft: -20,
                                marginRight: 14,
                                marginTop: 0,
                                marginBottom: 0,
                                top: 0,
                                left: 0,
                                fontItalic:1
                            },

                        },
                        content: { //右侧文本内容，目前只有一段文字
                            key: 'section1.22.4.14.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.22.4.14.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'See you.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体

                                    },
                                },

                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        // 段落内外间距
                        paragraphStyle: {
                            marginTop: 0,
                            marginBottom: 30,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                        }
                    },
                ],
                contentStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    padding: 20,
                    paddingTop: 0,
                    paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
            },
            {
                key: 'section1.22.5',
                type: "sound",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 49, // 行高  默认：46
                    maxWidth: 500,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },


        ],
    },
    // 小标题
    {
        key: 'section1.23',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Enjoy the Sound", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/Enjoy the Sound.png"),
        titleImageWidth: 524,
        titleImagePosition: 'left',
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 36, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 112, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    {
        key: 'section1.24',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Music", // *必填* 标题文本内容
        titleImageType: 1,
        titleImage: require("@/assets/images/books/book2/title-icon1.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 20, // 首行缩进  标题前带图标的写30，不带图标的写20
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            marginLeft: 20,
            paddingRight: 20,
            margin: 24,
            marginTop: 20,
            marginBottom: 0,

        },

    },
    // 模板样式 单个带边框
    {
        key: 'section1.25',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 5,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [{
            key: 'section1.25.1',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
                type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                width: 55,
                height: 40,
                text: 'I',
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    fontSize: 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#5CA683', // 背景颜色  默认：无
                    backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                    paddingLeft: 0,
                    paddingRight: 15,
                    marginLeft: 0,
                    marginRight: 14,
                    marginTop: 0,
                    marginBottom: 0,
                    top: 0,
                    left: 0,
                },
                popContent: { // 气泡
                    key: 'section1.25.2.1', // *必填* 唯一标识
                    category: 'popover', // *必填* 内容类型 text：文本
                    // text: '轴线', // *必填* 文本内容
                    textSlot: 1, // 是否以插槽方式引入内容
                    // popTitle: '轴线的名词解释',
                    popText: '',
                    content: [{
                        key: 'section1.25.2.1.1', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.25.2.1.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Suggested Answers', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Arial-BoldMT', // 字体，本地配置的字体
                                    fontSize: '24px',
                                    fontWeight: 'bold'
                                },
                            },
                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.25.2.1.2', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.25.2.1.2.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '1. hanging', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                                    fontSize: '24px',

                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.25.2.1.3', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.25.2.1.3.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '2. autumn', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                                    fontSize: '24px',

                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.25.2.1.4', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.25.2.1.4.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '3. profound', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                                    fontSize: '24px',

                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.25.2.1.5', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.25.2.1.5.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '4. Adored', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                                    fontSize: '24px',

                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.25.2.1.6', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.25.2.1.6.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '5. emptiness', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                                    fontSize: '24px',

                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },


                    ],
                    textStyle: {

                    },
                },
            },
            content: { //右侧文本内容，目前只有一段文字
                key: 'section1.26.2.2', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.26.2.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: ' Listen to the song and fill in the blanks.', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'ArialMT', // 字体，本地配置的字体
                            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        },
                    }
                ],
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },
            },
            // 段落内外间距
            paragraphStyle: {
                marginTop: 0,
                marginBottom: 50,
                padding: 0,
                paddingLeft: 20,
                paddingRight: 20,
            }
        },
        // 视频
        {
            key: 'section1.27.1.0', // *必填* 唯一标识
            type: 'video', // *必填* 类型：视频
            templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
            playerInline: 1, // 是否是行内播放 1：行内播放
            styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
            content: [ // *必填* 视频列表
                {
                    key: 'section1.27.1.1.1', // *必填* 唯一标识
                    url: require("@/assets/video/book2/2-6-2 Mid-Autumn’s Moon.mp4"), // *必填* 视频地址
                    left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                    title: '2-6-2 Mid-Autumn’s Moon', // 视频标题
                    subtitle: '2-6-2 Mid-Autumn’s Moon', // 视频副标题 只在全部显示时使用
                    titleStyle: {
                        // 根据需要是否加标题样式
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        // color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    }
                },
            ],
        },
        //正文
        {
            key: 'section1.28.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.28.1.1', // *必填* 唯一标识
                    category: 'popover', // *必填* 内容类型 text：文本
                    text: 'Mid-Autumn’s Moon', // *必填* 文本内容
                    popTitle: 'Background Information',
                    popText: '“Mid-Autumn’s Moon”是年轻音乐人肖恩·吉布森(Shaun Gibson)翻唱的英文版《明月几时有》。肖恩曾在西交利物浦大学学习中文，凭借其音乐天赋和对中国文化的热爱，肖恩翻唱了许多耳熟能详的中国歌曲，缔造出“中西合璧”且深具互联网娱乐精神的音乐风格，使他在中外社交平台都拥有不少的粉丝。肖恩的英文版歌词不是对于原歌词的简单直译，而是在保留相似情感的基础上的重新创作。相比于直接翻译歌词，肖恩以其英国人的语言优势可以表达出让英语世界更容易接受和理解的中国文化，为中国文化走向世界做出贡献。',
                    textStyle: {},
                },
            ],
            textStyle: {
                fontFamily: 'Calibri', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.5', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section3.3.22.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Watching the moon so bright', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.6', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section3.3.28.6.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'In the sky a ', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section3.3.28.6.2', // *必填* 唯一标识
                    category: 'input', // *必填* 内容类型 text：文本
                    text: '', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section3.3.28.6.3', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: ' light', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.7', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section3.3.28.7.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Gazing down on everyone', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },

            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.8', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section3.3.28.8.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Above this ', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section3.3.28.8.2', // *必填* 唯一标识
                    category: 'input', // *必填* 内容类型 text：文本
                    text: '', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section3.3.28.6.3', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: ' night', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.9', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.9.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'I wish I could be so ', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section1.3.28.9.2', // *必填* 唯一标识
                    category: 'input', // *必填* 内容类型 text：文本
                    text: '', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },

            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.10', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.10.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'And light up the world all around', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.11', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.11.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'But flying high upon a cloud', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.12', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.12.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Will end in falling down', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.13', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.13.2', // *必填* 唯一标识
                    category: 'input', // *必填* 内容类型 text：文本
                    text: '', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section1.3.28.13.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: ' with love yet unfound', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.131', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.131.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Rays shining silver cut through the dark shadow of loneliness', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.14', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.14.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'When two souls longing are touched by ethereal glow', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.15', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.15.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Soothes ', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
                {
                    key: 'section1.3.28.15.2', // *必填* 唯一标识
                    category: 'input', // *必填* 内容类型 text：文本
                    text: '', // *必填* 文本内容

                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },

            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.16', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.16.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Life brings joy and pain', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.17', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.17.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'The moon shines on through the rain', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.18', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.18.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Though now in person were parted', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.19', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.19.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'I’m never really far', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.20', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.20.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: 'Forever you’re in my heart', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        //正文
        {
            key: 'section1.28.21', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section1.3.28.21.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '…', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                    },
                },
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        {
            key: 'section1.29.1',
            type: 'paragraph',
            category: 'withBefore',
            leftMark: { // 左侧标记
                type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                width: 55,
                height: 40,
                text: 'II',
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    fontSize: 24, // 文字大小  默认：20
                    lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#5CA683', // 背景颜色  默认：无
                    backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                    paddingLeft: 0,
                    paddingRight: 15,
                    marginLeft: 0,
                    marginRight: 14,
                    marginTop: 0,
                    marginBottom: 0,
                    top: 0,
                    left: 0,
                },

            },
            content: { //右侧文本内容，目前只有一段文字
                key: 'section1.29.2.2', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section1.29.2.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'Learn the song and sing it in front of your classmates.', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'ArialMT', // 字体，本地配置的字体
                            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        },
                    }
                ],
                textStyle: {
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },
            },
            // 段落内外间距
            paragraphStyle: {
                marginTop: 0,
                marginBottom: 50,
                padding: 0,
                paddingLeft: 20,
                paddingRight: 20,
            }
        },
        ],
    },
    {
        key: 'section1.30',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Movie", // *必填* 标题文本内容
        titleImageType: 1,
        titleImage: require("@/assets/images/books/book2/title-icon1.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 20, // 首行缩进  标题前带图标的写30，不带图标的写20
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            marginLeft: 20,
            paddingRight: 20,
            margin: 24,
            marginTop: 20,
            marginBottom: 0,

        },

    },
    {
        key: 'section1.31',
        type: 'template',
        category: 2, // *必填* 分类 1：单个带边框 2：两级tabs
        content: [{
            key: 'section1.31.1',
            type: 'tab1',
            text: 'Chinese New Year',
            content: [{
                key: 'section1.31.1.1',
                type: 'tab2',
                text: 'Chinese New Year',
                width: 240,
                content: [
                    // 视频
                    {
                        key: 'section1.31.1.0', // *必填* 唯一标识
                        type: 'video', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                        playerInline: 1, // 是否是行内播放 1：行内播放
                        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                        content: [ // *必填* 视频列表
                            {
                                key: 'section1.31.1.1.1', // *必填* 唯一标识
                                url: require("@/assets/video/book2/2-7-1 Chinese New Year The Biggest Celebration on Earth .mp4"), // *必填* 视频地址
                                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                                title: '2-7-1 Chinese New Year The Biggest Celebration on Earth ', // 视频标题
                                subtitle: '2-7-1 Chinese New Year The Biggest Celebration on Earth ', // 视频副标题 只在全部显示时使用
                                titleStyle: {
                                    // 根据需要是否加标题样式
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    // fontSize: 20, // 文字大小  默认：20
                                    // lineHeight: 40, // 行高  默认：36
                                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                }
                            },
                        ],
                    },


                ]
            },

            ],
        },
        {
            key: 'section1.31.2',
            type: 'tab1',
            text: 'Understanding',
            content: [{
                key: 'section1.31.2.1',
                type: 'tab2',
                text: 'Understanding 1',
                width: 240,
                borderBottom: 1,
                content: [
                    // 视频
                    {
                        key: 'section1.31.2.0', // *必填* 唯一标识
                        type: 'video', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                        playerInline: 1, // 是否是行内播放 1：行内播放
                        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                        content: [ // *必填* 视频列表
                            {
                                key: 'section1.31.2.1.1', // *必填* 唯一标识
                                url: require("@/assets/video/book2/2-7-1 Chinese New Year The Biggest Celebration on Earth .mp4"), // *必填* 视频地址
                                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                                title: '2-7-1 Chinese New Year The Biggest Celebration on Earth ', // 视频标题
                                subtitle: '2-7-1 Chinese New Year The Biggest Celebration on Earth ', // 视频副标题 只在全部显示时使用
                                titleStyle: {
                                    // 根据需要是否加标题样式
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    // fontSize: 20, // 文字大小  默认：20
                                    // lineHeight: 40, // 行高  默认：36
                                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                }
                            },
                        ],
                    },
                    //正文
                    {
                        key: 'section1.31.3', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        showAnswerPop: true,
                        answerPopContent: {
                            key: 'section1.31.3.0', // *必填* 唯一标识
                            category: 'popover', // *必填* 内容类型 text：文本
                            text: '', // *必填* 文本内容
                            textSlot: 1,
                            textStyle: {},
                            content: [{
                                key: 'section1.31.3.0.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '参考答案', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                            fontSize: '24px',
                                            fontWeight: 'bold'
                                        },
                                    },
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    // fontSize: 20, // 文字大小  默认：20
                                    // lineHeight: 40, // 行高  默认：36
                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },
                            },
                            {
                                key: 'section1.31.3.0.2', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.2.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '1. known', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: '24px',

                                        },
                                    },
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    // fontSize: 20, // 文字大小  默认：20
                                    // lineHeight: 40, // 行高  默认：36
                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },
                            },
                            {
                                key: 'section1.31.3.0.3', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.3.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '2. by', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.4', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.4.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '3. migration', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.5', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.5.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '4. population', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.6', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.6.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '5. exploring', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.7', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.7.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '6. extraordinary', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.8', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.8.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '7. richness', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.9', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.9.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '8. prepare', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.10', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.10.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '9. on', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            {
                                key: 'section1.31.3.0.11', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section1.31.3.0.11.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '10. run up', // *必填* 文本内容
                                        textStyle: {},
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    color: '#111', // 文本颜色  默认：#00a8ac
                                },
                            },
                            ],
                        },
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.3.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'The Chinese New Year’s celebration is also ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.3.2.2', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '1.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.3.1.3', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' as the Spring Festival lasting 15 days. It’s the main holiday of the Chinese calendar. The start of the festival lands on a different day in January or February each year, as the date is decided ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.3.2.4', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '2.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.3.1.5', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' the lunar calendar. ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.4', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.4.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Chinese New Year sees the largest annual mass ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.4.2.2', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '3.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.4.2.3', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' people on the planet, when a sixth of the world’s ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.4.2.4', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '4.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.4.1.5', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' travels home to celebrate with their families.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.5', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.5.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'We’ve been all over China, ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.2', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '5.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.3', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' how this country experiences the most important festival in its calendar.We’ll uncover this ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.4', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '6.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.5', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' annual event and experience the ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.6', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '7.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.7', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' of Chinese culture, from how families ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.8', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '8.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.9', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' for festivities to the celebrations ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.10', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '9.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.5.2.11', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' the day itself.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.6', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.6.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'In this episode, we’ll be focusing on the ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.6.2.2', // *必填* 唯一标识
                                category: 'input', // *必填* 内容类型 text：文本
                                text: '', // *必填* 文本内容
                                defaultText: '10.',
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },
                            {
                                key: 'section1.31.6.2.3', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: ' to New Year, exploring how rural China used to celebrate New Year.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },


                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.7', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.7.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy New Year! Welcome to China.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.8', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.8.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy New Year!', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.9', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.9.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy Chinese New Year!', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 46, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },

                ]
            },
            {
                key: 'section1.31.2.2.2',
                type: 'tab2',
                text: 'Understanding 2',
                width: 240,
                borderBottom: 1,
                content: [
                    //正文
                    {
                        key: 'section1.31.2.2.1', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'The Chinese New Year’s celebration is also known as the Spring Festival lasting 15 days. It’s the main holiday of the Chinese calendar. The start of the festival lands on a different day in January or February each year, as the date is decided by the lunar calendar. ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            padding: 0,
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.2.2.2', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.2.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Chinese New Year sees the largest annual mass migration people on the planet, when a sixth of the world’s population travels home to celebrate with their families.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.2.2.3', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.3.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'We’ve been all over China, exploring how this country experiences the most important festival in its calendar.We’ll uncover this extraordinary annual event and experience the richness of Chinese culture, from how families prepare for festivities to the celebrations on the day itself.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.2.2.4', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.4.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'In this episode, we’ll be focusing on the run up to New Year, exploring how rural China used to celebrate New Year.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },


                    //正文
                    {
                        key: 'section1.31.2.2.5', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.5.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy New Year! Welcome to China.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.2.2.6', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.6.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy New Year!', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.31.2.2.7', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.2.2.7.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy Chinese New Year!', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //展开收起title
                    {
                        key: 'section1.31.2.2.8',
                        type: 'template',
                        category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                        templateStyle: {
                            margin: 0,
                        },
                        title: '中文翻译',
                        titleStyle: {
                            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                            // fontSize: 38, // 文字大小  默认：26
                            // lineHeight: 40, // 行高  默认：46
                            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#5CA683', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            // marginTop: 30,
                            // marginBottom: 30,
                            // padding: 0,
                            // paddingTop: 0,
                            // paddingBottom: 0,
                            // borderRadius: 0,
                            // border: '',
                            // borderTop: '',
                            // borderBottom: ''
                        },
                        content: [
                            {
                            key: 'section1.31.2.2.8', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '中国新年又被称作春节，节庆将持续15天。是中国历法中最重要的节日。春节的开始通常在每年一月或二月的某一天，因为这一日期是由农历决定的。', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.31.2.2.8.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '春节见证了地球上最大规模的年度人口迁移活动，全球六分之一的人口纷纷返回家乡与家人团圆。', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: '400'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.31.2.2.8.3', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.3.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '我们来到中国各地，探寻中国人如何度过日历中这一最重要的节日。我们将为您呈现这一年度盛事的景象，体验丰富多彩的中国文化，从春节前各家各户的筹备到节日当天的庆祝活动。', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.31.2.2.8.4', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.4.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '在本集中，我们将主要介绍春节前预热阶段，探寻中国乡村在过去如何欢度新年。', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: '400'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.31.2.2.8.5', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.5.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '新年快乐！欢迎来到中国。', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: '400'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.31.2.2.8.6', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.6.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '新年快乐！', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: '400'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section1.31.2.2.8.7', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section1.31.2.2.8.7.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '春节快乐！', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: '22px',
                                        // fontWeight: '400'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        ],
                        contentStyle: {
                            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                            // fontSize: 38, // 文字大小  默认：26
                            // lineHeight: 40, // 行高  默认：46
                            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#5CA683', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            // marginTop: 30,
                            // marginBottom: 30,
                            padding: 0,
                            paddingLeft: 20,
                            paddingRight: 20,
                            // paddingTop: 0,
                            // paddingBottom: 0,
                            // borderRadius: 0,
                            // border: '',
                            // borderTop: '',
                            // borderBottom: ''
                        },
                    },
                    //展开收起title
                    {
                        key: 'section1.31.3.2.8',
                        type: 'template',
                        category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                        templateStyle: {
                            margin: 0,
                        },
                        title: 'Words & Tips',
                        titleStyle: {

                        },
                        content: [{
                            key: 'section1.31.3.11',
                            type: "wordAudio",
                            category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                            // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                            text: "Words & Tips", // *必填* 标题文本内容
                            isexpand: false, //是否展开
                            // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                            textStyle: {
                                marginTop: 20
                                // fontFamily: 'Arial', // 字体，本地配置的字体
                                // fontSize: 26, // 文字大小  默认：26
                                // height:68,
                                // width:'auto',
                                // lineHeight: 68, // 行高  默认：46
                                // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                // color: '#fff', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                            },
                            content: [{
                                key: 'section1.31.3.11.1', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/01annual.mp3'), // 单词音频
                                content: [{
                                    key: 'section1.31.3.11.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'annual', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/ˈænjuəl/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'n. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '一年一度的；每年的',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }
                                ]
                            },
                            {
                                key: 'section1.31.2.2.11', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/02migration.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.2.11', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'migration', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/maɪˈɡreɪʃən/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'n. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '迁徙，移栖，迁移',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }
                                ],

                            },
                            {
                                key: 'section1.31.2.31', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/03population.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.6.2.3.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'population', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/ˌpɑpjəˈleɪʃ(ə)n/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'n. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '人口；人口数量；族群；（统称）某领域的生物',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }
                                ],

                            },
                            {
                                key: 'section1.31.2.41', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/04experience.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.41.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'experience', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/ɪkˈspɪəriəns/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'v. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '经历；体会到，感受到',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }
                                ],

                            }, {
                                key: 'section1.31.2.51', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/05uncover.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.51.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'uncover', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/ʌnˈkʌvə(r)/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'v. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '揭露，发现（秘密或隐藏物）；揭开（覆盖物）',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }
                                ],

                            },
                            {
                                key: 'section1.31.2.61', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/06extraordinary.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.61.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'extraordinary', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/ɪkˈstrɔː(r)d(ə)n(ə)ri/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'adj. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '非凡的；特别的；意想不到的；令人惊奇的',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }
                                ],

                            },
                            {
                                key: 'section1.31.2.71', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/07episode.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.71.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'episode', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '/ˈepɪsəʊd/', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: 'n. ',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28,
                                        fontItalic: 1,
                                        lineHeight: 36
                                    }
                                }, {
                                    text: '（尤指电视或广播节目的）一集，一节，片断',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }],

                            }, {
                                key: 'section1.31.2.81', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/08knownas.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.81.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'known as', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: '被称为；被认为是；以',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },{
                                    text: '……',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: '宋体', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },{
                                    text: '而闻名',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }],

                            }, {
                                key: 'section1.31.2.91', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/09bedecidedby.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.91.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'be decided by', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    ispop: true,
                                    popWord: true,
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/09bedecidedby.mp3'), // 单词音频,
                                    popWordTitle: [
                                        {
                                            key: 'section1.7.2.3.2.1',
                                            text: 'be decided by',
                                            textStyle: {fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                // fontSize: 18,
                                            }
                                        },
                                      
                                    ],
                                    popWordList: [
                                        {
                                            key: 'section1.7.2.3.2.4',
                                            text: '词以类记',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                // fontSize: 14
                                            },
                                            content: [
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    // textFlex: true,
                                                    textStyle: {
                                                    },
                                                    content: [
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'decide on：',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '决定；选定',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                    ]
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.2',
                                                    text: '',
                                                    // textFlex: true,
                                                    textStyle: {
                                                    },
                                                    content: [{
                                                        key: 'section1.7.2.3.2.4.2.2',
                                                        text: 'decide for sb. /sth.：',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            // fontSize: 13,
                                                            // lineHeight: 36
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.2.3',
                                                        text: '为某人或某事做出决定',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },]
                                                },
                                            {
                                                key: 'section1.7.2.3.2.4.3',
                                                text: '',
                                                // textFlex: true,
                                                textStyle: {
                                                },
                                                content: [{
                                                    key: 'section1.7.2.3.2.4.3.2',
                                                    text: 'decide to do：',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#333',
                                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        // fontSize: 13,
                                                        // lineHeight: 36
                                                    },
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.3.3',
                                                    text: '决定做某事',
                                                    textStyle: {
                                                        fontFamily: 'STXihei',
                                                        color: '#333',
                                                        // fontSize: 13,
                                                        // lineHeight: 36,
                                                    },
                                                },]
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.4',
                                                text: '',
                                                // textFlex: true,
                                                textStyle: {
                                                },
                                                content: [
    
                                                    {
                                                        key: 'section1.7.2.3.2.4.4.2',
                                                        text: 'decide upon：',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            // fontSize: 13,
                                                            // lineHeight: 36
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.4.3',
                                                        text: '考虑后决定；对',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.4.4',
                                                        text: '……',
                                                        textStyle: {
                                                            fontFamily: '宋体',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.4.5',
                                                        text: '作出决定',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                ]
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.5',
                                                text: '',
                                                // textFlex: true,
                                                textStyle: {
                                                },
                                                content: [
    
                                                    {
                                                        key: 'section1.7.2.3.2.4.5.2',
                                                        text: 'decide against：',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            // fontSize: 13,
                                                            // lineHeight: 36
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.5.3',
                                                        text: '决定不；作出不利于',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.5.4',
                                                        text: '……',
                                                        textStyle: {
                                                            fontFamily: '宋体',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.5.5',
                                                        text: '的判决',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                ]
                                            },
                                        ]},
                                    ],
                                    textStyle: {
                                        color: '#0482EC',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: '由',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '……',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: '宋体', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },
                                {
                                    text: '决定',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },],

                            }, {
                                key: 'section1.31.2.101', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/10preparedfor.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.101.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'prepared for', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    ispop: true,
                                    popWord: true,
                                    isPlay: false,
                                    word_url:require('@/assets/audio/2-1/10preparedfor.mp3'), // 单词音频,
                                    popWordTitle: [
                                        {
                                            key: 'section1.7.2.3.2.1',
                                            text: 'prepared for',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                // fontSize: 18,
                                            }
                                        },
                                    ],
                                    popWordList: [
                                        {
                                            key: 'section1.7.2.3.2.4',
                                            text: '词以类记',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                // fontSize: 14
                                            },
                                            content: [
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    // textFlex: true,
                                                    textStyle: {
                                                    },
                                                    content: [
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'prepare+',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '名词：准备；装备；起草',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                    ]
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {
                                                    },
                                                    content: [
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'I’m preparing a test.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: '我在准备一个考试。（我可能是老师）',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'I’m preparing for a test.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: '我在准备考试。（我是学生）',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                    ]
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    // textFlex: true,
                                                    textStyle: {
                                                    },
                                                    content: [{
                                                        key: 'section1.7.2.3.2.4.1.2',
                                                        text: 'be prepared to do something：',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            // fontSize: 13,
                                                            // lineHeight: 36
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.1.3',
                                                        text: '准备做某事',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                ]
                                            },
                                            {
                                                key: 'section1.7.2.3.2.4.1',
                                                text: '',
                                                textFlex: true,
                                                textStyle: {
                                                },
                                                content: [
                                                    {
                                                        key: 'section1.7.2.3.2.4.1.2',
                                                        text: 'e.g. ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            // fontSize: 13,
                                                            // lineHeight: 36
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.1.2',
                                                        text: 'We are prepared to learn English.',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            // fontSize: 13,
                                                            // lineHeight: 36
                                                        },
                                                    },
                                                    {
                                                        key: 'section1.7.2.3.2.4.1.3',
                                                        text: '我们做好学英语的准备了。',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            // fontSize: 13,
                                                            // lineHeight: 36,
                                                        },
                                                    },
                                                ]
                                            },
                                        ]
                                    },
                                    ],
                                    textStyle: {
                                        color: '#0482EC',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: '为',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },{
                                    text: '……',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: '宋体', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                },{
                                    text: '做准备',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }],

                            }, {
                                key: 'section1.31.2.111', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/11focuson.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.111.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'focus on', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: '聚焦于；集中于',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }],

                            }, {
                                key: 'section1.31.2.121', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/12runup.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.121.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'run up', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    textStyle: {
                                        color: '#333333',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: '事件的前奏曲，预备阶段；助跑',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }],
                            }, {
                                key: 'section1.31.2.131', // *必填* 唯一标识
                                type: "", // *必填*
                                // word_title: 'aristocrat', // 单词
                                isPlay: false, //是否播放
                                word_url: require('@/assets/audio/2-1/13usedtodosth.mp3'), // 单词音频
                                // word_title_style: {
                                //   color:'#333333',
                                //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                //   fontSize: 32, // 文字大小  默认：26
                                //   width:'auto',
                                //   fontWeight:'bold',
                                //   lineHeight:36
                                //  },
                                content: [{
                                    key: 'section1.31.2.131.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'used to do sth.', // *必填* 文本内容
                                    popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                    popText: '', // 气泡的内容
                                    popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                    ispop: true,
                                    popWord: true,
                                    isPlay: false,
                                    word_url:require('@/assets/audio/2-1/13usedtodosth.mp3'), // 单词音频,
                                    popWordTitle: [
                                        {
                                            key: 'section1.7.2.3.2.1',
                                            text: 'used to do sth.',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                // fontSize: 18,
                                            }
                                        },  
                                    ],
                                    popWordList: [
                                        {
                                            key: 'section1.7.2.3.2.4',
                                            text: '词以类记',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                // fontSize: 14
                                            },
                                            content: [
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    // textFlex: true,
                                                    textStyle: {},
                                                    content: [
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'be/get used to doing sth.：',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '习惯于做某事',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                    ]
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    // textFlex: true,
                                                    textStyle: {},
                                                    content: [
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'be used to do sth.：',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '被用于做某事',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                    ]
                                                },
                                                {
                                                    key: 'section1.7.2.3.2.4.1',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'I used to be afraid of dark.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '我过去害怕黑暗。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'People should get used to travelling by public transportation.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '人们应该习惯于乘坐公共交通工具出行。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.2',
                                                            text: 'Stamps can be used to send letters.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.7.2.3.2.4.1.3',
                                                            text: '邮票可以用来寄信。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                    ]
                                                },
                                        ]
                                    },
                                    ],
                                    textStyle: {
                                        color: '#0482EC',
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 32, // 文字大小  默认：26
                                        width: 'auto',
                                        fontWeight: 'bold',
                                        lineHeight: 36
                                    },
                                },],
                                word_mark: '', // 音标
                                word_mark_style: {
                                    color: '#999999',
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    width: 'auto',
                                    lineHeight: 36
                                },
                                word_translate: [{
                                    text: '过去常常做某事',
                                    textStyle: {
                                        color: '#999999',
                                        fontFamily: 'STXihei', // 字体，本地配置的字体
                                        fontSize: 22,
                                        lineHeight: 36
                                    }
                                }],

                            }
                            ]
                        },],
                        contentStyle: {
                            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                            // fontSize: 38, // 文字大小  默认：26
                            // lineHeight: 40, // 行高  默认：46
                            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#5CA683', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            width: '100%',
                            margin: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            padding: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            // borderRadius: 0,
                            // border: '',
                            // borderTop: '',
                            // borderBottom: ''
                        },
                    },

                ],
                contentStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    padding: 0,
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
            },

            ]
        },
        {
            key: 'section1.31.3',
            type: 'tab1',
            text: 'Language in use',
            content: [{
                key: 'section1.31.3.1',
                type: 'tab2',
                text: 'Words in use',
                width: 246,
                content: [
                    // 互动答题
                    {
                        key: 'section1.31.3.1.1', // *必填* 唯一标识
                        type: 'interactionQuestion', // *必填* 类型：
                        content: [ // *必填* 答题列表
                            // 单项选择题
                            {
                                "key": "question1.1",
                                "topic_id": 1,
                                "id": 1,
                                "type_id": 1,
                                "typenm": "单项选择题",
                                "shorttag": "",
                                "showway": "",
                                "topic_score": "1.00",
                                "isauto": 0,
                                "info": "",
                                "km": "",
                                "stem_url": "",
                                "audiofile": "",
                                "audiofile_suffix": "",
                                "audiofile_title": "附件下载",
                                "is_collect": 0,
                                "status": 0,
                                "is_play": 0,
                                "issign": 0,
                                "isok": 0,
                                "isdone": 0,
                                "getscore": 0,
                                "comment": "",
                                "ischeck": 0,
                                "ps_title": "",
                                "ps_info": "",
                                "topic_sub": [
                                    {
                                        "key": "question1.1.1",
                                        "shorttag": "",
                                        "direction": 0,
                                        "type_id": 1,
                                        "typenm": "单项选择题",
                                        "score": "1.00",
                                        "topic_id": 1,
                                        "sub_id": 1,
                                        "isauto": 0,
                                        "isExample": 0,
                                        "para44_id": 0,
                                        "upload_explain": "",
                                        "options": [],
                                        "showway": "",
                                        "subinfo": "<p><span style=\"font-family:Calibri; font-weight: bold; color: #333;\">1. She is _____ us a meal.<\/span><\/p>",
                                        // "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                                        // "subanalysis": "<p><span style=\"font-family:微软雅黑\">导致亚健康的原因主要有以下几个方面：<\/span><\/p> <p><span style=\"font-family:微软雅黑\">①过度疲劳造成的精力体力透支；②人体自然衰老，机体器官开始老化出现的体力不支；③处于重病恢复期；④人体生物周期中的低潮导致维持生命的器官运行和新陈代谢等生物节律的紊乱；⑤个人的不良生活方式；⑥社会环境及人性需求产生的压力；⑦环境污染的影响。<\/span><\/p>",
                                        "sortid": 1,
                                        "file_name": "",
                                        "user_answer": [],
                                        "brief_answer": {},
                                        "user_status": -1,
                                        "answer": 1,
                                        "answer_img": {},
                                        "topic_answer": [
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">A. preparing<\/span><\/p>",
                                                "answer": "1",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 2,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">B. preparing for<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 2,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 3,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">C. preparing to<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 3,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 4,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">D. prepare<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 4,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                        ],
                                        "video_list": [],
                                        "isok": 0,
                                        "isdone": 0,
                                        "concat_answer": "A",
                                        "user_concat_answer": ""
                                    }
                                ]
                            },
                            // 单项选择题
                            {
                                "key": "question1.2",
                                "topic_id": 2,
                                "id": 2,
                                "type_id": 1,
                                "typenm": "单项选择题",
                                "shorttag": "",
                                "showway": "",
                                "topic_score": "1.00",
                                "isauto": 0,
                                "info": "",
                                "km": "",
                                "stem_url": "",
                                "audiofile": "",
                                "audiofile_suffix": "",
                                "audiofile_title": "附件下载",
                                "is_collect": 0,
                                "status": 0,
                                "is_play": 0,
                                "issign": 0,
                                "isok": 0,
                                "isdone": 0,
                                "getscore": 0,
                                "comment": "",
                                "ischeck": 0,
                                "ps_title": "",
                                "ps_info": "",
                                "topic_sub": [
                                    {
                                        "key": "question1.2.1",
                                        "shorttag": "",
                                        "direction": 0,
                                        "type_id": 1,
                                        "typenm": "单项选择题",
                                        "score": "1.00",
                                        "topic_id": 1,
                                        "sub_id": 1,
                                        "isauto": 0,
                                        "isExample": 0,
                                        "para44_id": 0,
                                        "upload_explain": "",
                                        "options": [],
                                        "showway": "",
                                        "subinfo": "<p><span style=\"font-family:Calibri; font-weight: bold; color: #333;\">2. He used to _____ in a small village, but now he has been used to _____ in the big city.<\/span><\/p>",
                                        // "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                                        // "subanalysis": "<p><span style=\"font-family:微软雅黑\">导致亚健康的原因主要有以下几个方面：<\/span><\/p> <p><span style=\"font-family:微软雅黑\">①过度疲劳造成的精力体力透支；②人体自然衰老，机体器官开始老化出现的体力不支；③处于重病恢复期；④人体生物周期中的低潮导致维持生命的器官运行和新陈代谢等生物节律的紊乱；⑤个人的不良生活方式；⑥社会环境及人性需求产生的压力；⑦环境污染的影响。<\/span><\/p>",
                                        "sortid": 1,
                                        "file_name": "",
                                        "user_answer": [],
                                        "brief_answer": {},
                                        "user_status": -1,
                                        "answer": 1,
                                        "answer_img": {},
                                        "topic_answer": [
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">A. live; living<\/span><\/p>",
                                                "answer": "1",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 2,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">B. live; live<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 2,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 3,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">C. living; living<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 3,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 4,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">D. living; live<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 4,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                        ],
                                        "video_list": [],
                                        "isok": 0,
                                        "isdone": 0,
                                        "concat_answer": "A",
                                        "user_concat_answer": ""
                                    }
                                ]
                            },
                            // 单项选择题
                            {
                                "key": "question1.3",
                                "topic_id": 3,
                                "id": 3,
                                "type_id": 1,
                                "typenm": "单项选择题",
                                "shorttag": "",
                                "showway": "",
                                "topic_score": "1.00",
                                "isauto": 0,
                                "info": "",
                                "km": "",
                                "stem_url": "",
                                "audiofile": "",
                                "audiofile_suffix": "",
                                "audiofile_title": "附件下载",
                                "is_collect": 0,
                                "status": 0,
                                "is_play": 0,
                                "issign": 0,
                                "isok": 0,
                                "isdone": 0,
                                "getscore": 0,
                                "comment": "",
                                "ischeck": 0,
                                "ps_title": "",
                                "ps_info": "",
                                "topic_sub": [
                                    {
                                        "key": "question1.3.1",
                                        "shorttag": "",
                                        "direction": 0,
                                        "type_id": 1,
                                        "typenm": "单项选择题",
                                        "score": "1.00",
                                        "topic_id": 1,
                                        "sub_id": 1,
                                        "isauto": 0,
                                        "isExample": 0,
                                        "para44_id": 0,
                                        "upload_explain": "",
                                        "options": [],
                                        "showway": "",
                                        "subinfo": "<p><span style=\"font-family:Calibri; font-weight: bold; color: #333;\">3. Stone can _____ bridges.<\/span><\/p>",
                                        // "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                                        // "subanalysis": "<p><span style=\"font-family:微软雅黑\">导致亚健康的原因主要有以下几个方面：<\/span><\/p> <p><span style=\"font-family:微软雅黑\">①过度疲劳造成的精力体力透支；②人体自然衰老，机体器官开始老化出现的体力不支；③处于重病恢复期；④人体生物周期中的低潮导致维持生命的器官运行和新陈代谢等生物节律的紊乱；⑤个人的不良生活方式；⑥社会环境及人性需求产生的压力；⑦环境污染的影响。<\/span><\/p>",
                                        "sortid": 1,
                                        "file_name": "",
                                        "user_answer": [],
                                        "brief_answer": {},
                                        "user_status": -1,
                                        "answer": 2,
                                        "answer_img": {},
                                        "topic_answer": [
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">A. used to build<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 2,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">B. be used to build<\/span><\/p>",
                                                "answer": "1",
                                                "askend": null,
                                                "answer_id": 2,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 3,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">C. be used to building<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 3,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 4,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">D. used for building<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 4,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                        ],
                                        "video_list": [],
                                        "isok": 0,
                                        "isdone": 0,
                                        "concat_answer": "B",
                                        "user_concat_answer": ""
                                    }
                                ]
                            },
                            // 单项选择题
                            {
                                "key": "question1.4",
                                "topic_id": 4,
                                "id": 4,
                                "type_id": 1,
                                "typenm": "单项选择题",
                                "shorttag": "",
                                "showway": "",
                                "topic_score": "1.00",
                                "isauto": 0,
                                "info": "",
                                "km": "",
                                "stem_url": "",
                                "audiofile": "",
                                "audiofile_suffix": "",
                                "audiofile_title": "附件下载",
                                "is_collect": 0,
                                "status": 0,
                                "is_play": 0,
                                "issign": 0,
                                "isok": 0,
                                "isdone": 0,
                                "getscore": 0,
                                "comment": "",
                                "ischeck": 0,
                                "ps_title": "",
                                "ps_info": "",
                                "topic_sub": [
                                    {
                                        "key": "question1.4.1",
                                        "shorttag": "",
                                        "direction": 0,
                                        "type_id": 1,
                                        "typenm": "单项选择题",
                                        "score": "1.00",
                                        "topic_id": 1,
                                        "sub_id": 1,
                                        "isauto": 0,
                                        "isExample": 0,
                                        "para44_id": 0,
                                        "upload_explain": "",
                                        "options": [],
                                        "showway": "",
                                        "subinfo": "<p><span style=\"font-family:Calibri; font-weight: bold; color: #333;\">4. The investigation _____ evidence of a large-scale illegal trade in wild birds.<\/span><\/p>",
                                        // "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                                        // "subanalysis": "<p><span style=\"font-family:微软雅黑\">导致亚健康的原因主要有以下几个方面：<\/span><\/p> <p><span style=\"font-family:微软雅黑\">①过度疲劳造成的精力体力透支；②人体自然衰老，机体器官开始老化出现的体力不支；③处于重病恢复期；④人体生物周期中的低潮导致维持生命的器官运行和新陈代谢等生物节律的紊乱；⑤个人的不良生活方式；⑥社会环境及人性需求产生的压力；⑦环境污染的影响。<\/span><\/p>",
                                        "sortid": 1,
                                        "file_name": "",
                                        "user_answer": [],
                                        "brief_answer": {},
                                        "user_status": -1,
                                        "answer": 4,
                                        "answer_img": {},
                                        "topic_answer": [
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">A. cover<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 2,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">B. covered<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 2,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 3,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">C. uncover<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 3,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 4,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">D. uncovered<\/span><\/p>",
                                                "answer": "1",
                                                "askend": null,
                                                "answer_id": 4,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                        ],
                                        "video_list": [],
                                        "isok": 0,
                                        "isdone": 0,
                                        "concat_answer": "D",
                                        "user_concat_answer": ""
                                    }
                                ]
                            },
                            // 单项选择题
                            {
                                "key": "question1.5",
                                "topic_id": 5,
                                "id": 5,
                                "type_id": 1,
                                "typenm": "单项选择题",
                                "shorttag": "",
                                "showway": "",
                                "topic_score": "1.00",
                                "isauto": 0,
                                "info": "",
                                "km": "",
                                "stem_url": "",
                                "audiofile": "",
                                "audiofile_suffix": "",
                                "audiofile_title": "附件下载",
                                "is_collect": 0,
                                "status": 0,
                                "is_play": 0,
                                "issign": 0,
                                "isok": 0,
                                "isdone": 0,
                                "getscore": 0,
                                "comment": "",
                                "ischeck": 0,
                                "ps_title": "",
                                "ps_info": "",
                                "topic_sub": [
                                    {
                                        "key": "question1.5.1",
                                        "shorttag": "",
                                        "direction": 0,
                                        "type_id": 1,
                                        "typenm": "单项选择题",
                                        "score": "1.00",
                                        "topic_id": 1,
                                        "sub_id": 1,
                                        "isauto": 0,
                                        "isExample": 0,
                                        "para44_id": 0,
                                        "upload_explain": "",
                                        "options": [],
                                        "showway": "",
                                        "subinfo": "<p><span style=\"font-family:Calibri; font-weight: bold; color: #333;\">5. The density of _____ in this city is very high.<\/span><\/p>",
                                        // "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                                        // "subanalysis": "<p><span style=\"font-family:微软雅黑\">导致亚健康的原因主要有以下几个方面：<\/span><\/p> <p><span style=\"font-family:微软雅黑\">①过度疲劳造成的精力体力透支；②人体自然衰老，机体器官开始老化出现的体力不支；③处于重病恢复期；④人体生物周期中的低潮导致维持生命的器官运行和新陈代谢等生物节律的紊乱；⑤个人的不良生活方式；⑥社会环境及人性需求产生的压力；⑦环境污染的影响。<\/span><\/p>",
                                        "sortid": 1,
                                        "file_name": "",
                                        "user_answer": [],
                                        "brief_answer": {},
                                        "user_status": -1,
                                        "answer": 2,
                                        "answer_img": {},
                                        "topic_answer": [
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">A. people<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 2,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">B. population<\/span><\/p>",
                                                "answer": "1",
                                                "askend": null,
                                                "answer_id": 2,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 3,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">C. residents<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 3,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                            {
                                                "topic_id": 1,
                                                "sub_id": 1,
                                                "sortid": 4,
                                                "ask": "<p><span style=\"font-family:Calibri; color: #333;\">D. citizens<\/span><\/p>",
                                                "answer": "0",
                                                "askend": null,
                                                "answer_id": 4,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "0.00",
                                                "operation_score": 0
                                            },
                                        ],
                                        "video_list": [],
                                        "isok": 0,
                                        "isdone": 0,
                                        "concat_answer": "B",
                                        "user_concat_answer": ""
                                    }
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                key: 'section1.31.3.2',
                type: 'tab2',
                text: 'Dub the clip',
                width: 246,
                content: [
                    //正文
                    {
                        key: 'section1.31.16.2.1', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.16.2.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'The Chinese New Year’s celebration is also known as the Spring Festival lasting 15 days. It’s the main holiday of the Chinese calendar. The start of the festival lands on a different day in January or February each year, as the date is decided by the lunar calendar. ', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            padding: 0,
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.17.2.2', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.17.2.2.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Chinese New Year sees the largest annual mass migration people on the planet, when a sixth of the world’s population travels home to celebrate with their families.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.18.2.3', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.18.2.3.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'We’ve been all over China, exploring how this country experiences the most important festival in its calendar.We’ll uncover this extraordinary annual event and experience the richness of Chinese culture, from how families prepare for festivities to the celebrations on the day itself.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.19.2.4', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.19.2.4.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'In this episode, we’ll be focusing on the run up to New Year, exploring how rural China used to celebrate New Year.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },


                    //正文
                    {
                        key: 'section1.31.20.2.5', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.20.2.5.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy New Year! Welcome to China.', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    //正文
                    {
                        key: 'section1.31.21.2.6', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.21.2.6.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy New Year!', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.31.22.2.7', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.31.22.2.7.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Happy Chinese New Year!', // *必填* 文本内容
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                },
                            },

                        ],
                        textStyle: {
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            //textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.31.23',
                        type: "sound",
                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                        text: "", // *必填* 标题文本内容
                        titleImageType: 3,
                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                        textStyle: {
                            fontFamily: 'Arial', // 字体，本地配置的字体
                            fontSize: 26, // 文字大小  默认：26
                            height: 49,
                            width: 'auto',
                            lineHeight: 49, // 行高  默认：46
                            maxWidth: 500,
                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#fff', // 文本颜色  默认：#00a8ac
                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                            borderRadius: {
                                borderTopLeftRadius: 20,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 20,
                                borderBottomLeftRadius: 0
                            }
                        },
                    },
                ]
            },
            ]
        }
        ],
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 5,
            marginBottom: 30,
            // padding: 0,
            // paddingTop: 0,
            // paddingBottom: 0,
            // borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        }
    },
]
export default content
